function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CreatePostTemplate = require('./create-post.template');
var _require = require('../post-document'),
  parseMarkdownToDocument = _require.parseMarkdownToDocument,
  serializeDocumentToMarkdown = _require.serializeDocumentToMarkdown,
  renderDocument = _require.renderDocument,
  generateBlockId = _require.generateBlockId;

/**
 * ============================================================================
 * EDITOR STRUCTURAL INVARIANTS
 * ============================================================================
 *
 * These invariants define the core semantics of the editor and must be
 * maintained by all code paths. Violations cause race conditions, stale state,
 * and unpredictable behavior.
 *
 * 1. DOM IS SINGLE SOURCE OF TRUTH
 *    - During editing, the DOM is authoritative
 *    - JavaScript state is DERIVED from DOM, never authoritative
 *    - No parallel document/block model exists during live editing
 *
 * 2. STRUCTURAL CHANGES ARE ENTER-AUTHORITATIVE
 *    - Structural block changes (headings, lists, blockquotes) occur ONLY on
 *      Enter keydown events
 *    - input events may change text content but MUST NOT change block structure
 *    - This ensures deterministic behavior and prevents race conditions
 *
 * 3. SELECTION/RANGE ARE VOLATILE
 *    - Selection and Range objects become stale after any DOM mutation
 *    - They must be re-read immediately before use, never cached across
 *      DOM changes
 *    - Early capture and reuse causes incorrect cursor positions
 *
 * 4. NORMALIZATION VS COMPLETION
 *    - Normalization (block type conversion) never creates sibling blocks
 *    - Normalization updates focusedBlock and blockType in place
 *    - Enter completion always creates sibling blocks (new paragraphs/list items)
 *    - These are separate phases that must not be conflated
 *
 * 5. ENTER COMPLETION IS MANDATORY
 *    - Every Enter keypress must result in exactly one structural change
 *    - Normalization must NOT return early or consume the Enter action
 *    - Enter completion logic always runs after normalization
 *    - Early returns after normalization are forbidden
 *
 * 6. NO STRUCTURAL CONVERSION OUTSIDE handleEnterKey()
 *    - checkAutoConversion() is a no-op (structural conversion removed)
 *    - All structural conversion happens in handleEnterKey() only
 *    - This prevents race conditions and empty blocks during typing
 *
 * ============================================================================
 */
var CreatePost = /*#__PURE__*/function () {
  function CreatePost(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, CreatePost);
    this.app = app;
    this.mod = mod;
    this.container = container;

    // ========================================================================
    // CONFIGURABLE SAVE THRESHOLDS
    // ========================================================================
    // Resolve save thresholds from module config or use defaults
    // Module can optionally set: mod.save_after_inactivity, mod.save_after_bytes, mod.save_after_editing
    var DEFAULT_SAVE_AFTER_INACTIVITY = 1500; // ms
    var DEFAULT_SAVE_AFTER_BYTES = 300; // characters
    var DEFAULT_SAVE_AFTER_EDITING = 30000; // ms (30 seconds)

    this.save_after_inactivity = typeof mod.save_after_inactivity === 'number' ? mod.save_after_inactivity : DEFAULT_SAVE_AFTER_INACTIVITY;
    this.save_after_bytes = typeof mod.save_after_bytes === 'number' ? mod.save_after_bytes : DEFAULT_SAVE_AFTER_BYTES;
    this.save_after_editing = typeof mod.save_after_editing === 'number' ? mod.save_after_editing : DEFAULT_SAVE_AFTER_EDITING;

    // Save state tracking
    this.serializeTimeout = null;
    this.inactivityTimeout = null;
    this.editingTimer = null;
    this.editingStartTime = null;
    this.lastSaveContent = null; // Track content at last save
    this.lastTrackedContent = null; // Track content from last scheduleSerialization call (for incremental tracking)
    this.changedBytes = 0; // Track total bytes changed since last save
    this.isSaving = false; // Track if save is in-flight
    this.queuedSave = false; // Track if save is queued (editor became dirty during save)
    this.isComposing = false; // Track IME composition state

    this.saveState = 'draft'; // 'draft', 'saving', 'saved'
    this.saveStateTimeout = null;
    this.savingStartTime = null; // Track when saving started (for minimum visibility guarantee)
    this.storedDropRange = null; // Store Range for drop position (legacy)
    this.storedInsertionPoint = null; // Store insertion point that matches visual indicator (single source of truth)
    this.isDragging = false; // Track drag state
    this.isPublished = false; // Track if post is published
    this.parent_id = null; // Track root post signature when editing published posts (null for new posts/drafts)
    this.draftTransaction = null; // Track current draft transaction (unsigned, saved to localhost)
    this.eventsAttached = false; // Track if event listeners have been attached (prevents double attachment)
    this.sessionIntent = null; // Session intent: { mode: 'resume'|'select'|'new', draftId?: string }
    this.activeDraftId = null; // Active draft ID for this session (bound to autosave)
    this.featuredImage = null; // Featured/teaser image (base64 data, stored in tx.msg.image)
    this.pendingIntent = null; // Intent to use on next render() call (set by handleStartWriting for draft detection)
    // Distribution options for the publish overlay (survive overlay open/close).
    this.publishDistribution = {
      linkToProfile: true,
      tweetOnPublish: true
    };
  }
  return _createClass(CreatePost, [{
    key: "render",
    value: function render() {
      var _this = this;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // ========================================================================
      // INVARIANT 4: Unmount before re-entering editor (navigation path: editor → editor)
      // ========================================================================
      // If editor is already mounted, unmount first to clean up timers/state
      if (this.isEditorMounted()) {
        this.onEditorUnmount();
      }

      // ========================================================================
      // LIFECYCLE: Reset ALL session-local state for fresh editing session
      // ========================================================================
      // CreatePost is long-lived, so we must explicitly reset all session state
      // on every mount, regardless of previous session state
      this.resetSessionState();
      if (container !== '') {
        this.container = container;
      }
      if (!this.container || this.container.trim() === '') {
        this.container = '.saito-container';
      }
      var html = CreatePostTemplate(this.app, this.mod);

      // ========================================================================
      // FIX: Use replaceElementContentBySelector to preserve .saito-container
      // ========================================================================
      // replaceElementBySelector replaces the container itself (obj.outerHTML = html)
      // This causes .saito-container to disappear, breaking mount verification.
      // Use replaceElementContentBySelector to replace only the inner content,
      // preserving the container element so mount verification works correctly.
      this.app.browser.replaceElementContentBySelector(html, this.container);

      // Update container class
      var containerEl = document.querySelector(this.container);
      if (containerEl) {
        containerEl.classList.remove('stack-splash-container');
        containerEl.classList.add('stack-create-post-container');
      }

      // Trigger mount transition on next animation frame
      // This allows the initial state (opacity: 0) to render first
      requestAnimationFrame(function () {
        var pageEl = document.querySelector('.create-post');
        if (pageEl) {
          pageEl.classList.add('mounted');
        }
      });

      // ========================================================================
      // LIFECYCLE: Initialize document and mount editor
      // ========================================================================
      // Mount happens FIRST (infrastructure), draft loading happens SECOND (data)
      // Draft loading must NOT suppress mount - mount is independent of draft state
      // INVARIANT 2: Editor requires explicit intent - default to "new" mode if no intent provided
      // Note: If intent is provided externally (e.g., from handleStartWriting), it will be used
      // Otherwise, default to "new" mode
      var defaultIntent = this.pendingIntent || {
        mode: 'new'
      };
      this.pendingIntent = null; // Clear after use
      this.initializeDocument(defaultIntent).then(function () {
        _this.onEditorMount();
        // Update featured image display after mount (in case draft was loaded)
        setTimeout(function () {
          _this.updateFeaturedImageDisplay();
        }, 100);
      })["catch"](function (err) {
        console.error('Stack: Error initializing document:', err);
        // Even if document initialization fails, attempt mount (infrastructure must be ready)
        _this.onEditorMount();
        setTimeout(function () {
          _this.updateFeaturedImageDisplay();
        }, 100);
      });
    }

    /**
     * Initialize document based on explicit session intent
     *
     * SESSION INTENT OBJECT: { mode: 'resume'|'select'|'new'|'choose', draftId?: string }
     *
     * Branching logic:
     * - mode: 'new' → Initialize empty editor (draft created lazily on first edit)
     * - mode: 'resume' → Load draft by draftId (most recent draft)
     * - mode: 'select' → Load draft by draftId (specific draft from chooser)
     * - mode: 'choose' → Show draft chooser overlay and wait for user choice
     *
     * INVARIANT 2: Editor MUST NEVER guess intent from draft existence.
     * Intent must ALWAYS be explicitly provided. If missing, defaults to { mode: 'new' } with error log.
     *
     * NOTE: Does NOT attach event listeners - that happens in onEditorMount()
     */
  }, {
    key: "initializeDocument",
    value: function () {
      var _initializeDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(sessionIntent) {
        var _this2 = this;
        var editor;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              editor = document.querySelector('#stack-post-body-editor');
              if (editor) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              // ========================================================================
              // INVARIANT 2: Session intent is REQUIRED - no guessing allowed
              // ========================================================================
              if (!sessionIntent) {
                console.error('[EDITOR-INVARIANT] initializeDocument() called without sessionIntent - this violates INVARIANT 2');
                // Fail-safe: Default to "new" mode if intent is missing (but log error)
                sessionIntent = {
                  mode: 'new'
                };
              }

              // Store session intent for this session
              this.sessionIntent = sessionIntent;

              // ========================================================================
              // [EDITOR-INVARIANT] Log session start for validation
              // ========================================================================
              console.debug('[EDITOR-INVARIANT] Session started:', JSON.stringify(sessionIntent));

              // ========================================================================
              // INVARIANT 2: BRANCH ON INTENT - No inference from draft existence
              // ========================================================================
              if (!(sessionIntent.mode === 'choose')) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return this.showDraftChooserOverlay();
            case 2:
              return _context.a(2);
            case 3:
              if (!(sessionIntent.mode === 'new')) {
                _context.n = 4;
                break;
              }
              // Mode: new - Initialize empty editor, draft created lazily on first edit
              // INVARIANT 2: Do NOT check draft count - honor the explicit "new" intent
              this.activeDraftId = null;
              // PART 3 — BUTTON LABEL LOGIC: Reset parent_id for new posts
              this.parent_id = null; // New posts have no parent
              this.initializeEmptyEditor();
              _context.n = 8;
              break;
            case 4:
              if (!(sessionIntent.mode === 'resume' || sessionIntent.mode === 'select')) {
                _context.n = 7;
                break;
              }
              if (sessionIntent.draftId) {
                _context.n = 5;
                break;
              }
              console.error('[EDITOR-INVARIANT] initializeDocument() called with resume/select mode but no draftId');
              // Fail-safe: Default to empty editor
              this.activeDraftId = null;
              this.initializeEmptyEditor();
              return _context.a(2);
            case 5:
              this.activeDraftId = sessionIntent.draftId;

              // ========================================================================
              // [EDITOR-INVARIANT] Log draft bind for validation
              // ========================================================================
              console.debug('[EDITOR-INVARIANT] Draft bound to session:', sessionIntent.draftId);
              _context.n = 6;
              return this.loadDraftById(sessionIntent.draftId);
            case 6:
              _context.n = 8;
              break;
            case 7:
              console.error('[EDITOR-INVARIANT] initializeDocument() called with invalid session intent mode:', sessionIntent.mode);
              // Fail-safe: Default to empty editor
              this.activeDraftId = null;
              this.initializeEmptyEditor();
              return _context.a(2);
            case 8:
              // ========================================================================
              // INVARIANT CHECK: Verify session state after initialization
              // ========================================================================
              try {
                this.assertValidSessionIntent('after initializeDocument');
                this.assertActiveDraftConsistency('after initializeDocument');
              } catch (error) {
                console.error('[EDITOR-INVARIANT] Session state invariant violation after initialization:', error);
                // Continue - session may still be usable
              }

              // Ensure placeholder is shown if editor is empty
              this.updatePlaceholderVisibility();

              // Initialize save state
              this.updateSaveState('draft');

              // Update next step button state
              this.updateNextStepButton();

              // Update publish trigger visibility
              this.updatePublishTriggerVisibility();
              this.updatePublishTriggerState();

              // NOTE: Event listeners are attached in onEditorMount() after mount verification

              // Auto-focus title input on load if no content exists
              setTimeout(function () {
                var titleInput = document.querySelector('#stack-post-title-input');
                var editor = document.querySelector('#stack-post-body-editor');

                // Check if there's any existing content (read from DOM)
                var hasTitle = _this2.getDocumentTitle().length > 0;
                var hasBodyContent = editor && Array.from(editor.querySelectorAll('[data-block-id]')).some(function (blockEl) {
                  var blockType = blockEl.getAttribute('data-block-type');
                  if (blockType === 'paragraph' || blockType === 'heading' || blockType === 'list-item' || blockType === 'blockquote') {
                    var text = (blockEl.textContent || '').replace(/\u200B/g, '').trim();
                    return text.length > 0;
                  }
                  if (blockType === 'image') {
                    return true;
                  }
                  if (blockType === 'rawhtml') {
                    return (blockEl.innerHTML || '').trim().length > 0;
                  }
                  return false;
                });

                // If no content exists, focus title input
                if (!hasTitle && !hasBodyContent && titleInput) {
                  titleInput.focus();
                } else if (editor && hasBodyContent) {
                  // If body has content, focus body editor
                  var firstBlock = editor.querySelector('[contenteditable="true"]');
                  if (firstBlock) {
                    var range = document.createRange();
                    var selection = window.getSelection();

                    // Ensure the block has a text node for cursor placement
                    if (!firstBlock.firstChild || firstBlock.firstChild.nodeType !== Node.TEXT_NODE) {
                      var textNode = document.createTextNode("\u200B");
                      firstBlock.appendChild(textNode);
                    }

                    // Place cursor at the start of the text node
                    if (firstBlock.firstChild && firstBlock.firstChild.nodeType === Node.TEXT_NODE) {
                      range.setStart(firstBlock.firstChild, 0);
                      range.setEnd(firstBlock.firstChild, 0);
                      range.collapse(true);
                      selection.removeAllRanges();
                      selection.addRange(range);
                    }
                  }
                }
              }, 50);
            case 9:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initializeDocument(_x) {
        return _initializeDocument.apply(this, arguments);
      }
      return initializeDocument;
    }()
    /**
     * Show the draft chooser overlay
     * Only called when draftCount > 0
     * Editor should already be rendered with most recent draft behind the overlay
     */
  }, {
    key: "showDraftChooserOverlay",
    value: function () {
      var _showDraftChooserOverlay = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this3 = this;
        var hasValidDrafts, ChooseDraftOverlay;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              // ========================================================================
              // INVARIANT: Hard guard before showing overlay - must have valid drafts
              // ========================================================================
              // [DRAFT-CHECK] Log entry
              console.log('[DRAFT-CHECK] showDraftChooserOverlay() called');

              // Ensure drafts are discovered before checking validity
              if (!this.mod.discoverDrafts) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return this.mod.discoverDrafts();
            case 1:
              // Check if there are valid drafts using centralized function
              hasValidDrafts = this.mod.hasValidDrafts && this.mod.hasValidDrafts();
              console.log('[DRAFT-CHECK] intent=choose hasValidDrafts=' + hasValidDrafts);
              if (hasValidDrafts) {
                _context3.n = 3;
                break;
              }
              // ========================================================================
              // HARD GUARD: No valid drafts - force editor initialization with "new" mode
              // ========================================================================
              console.log('[DRAFT-CHECK] Overlay blocked - no valid drafts exist, forcing mode="new"');
              _context3.n = 2;
              return this.initializeDocument({
                mode: 'new'
              });
            case 2:
              return _context3.a(2);
            case 3:
              // Valid drafts exist - proceed with showing overlay
              console.log('[DRAFT-CHECK] Overlay allowed - valid drafts exist');

              // Lazy-load overlay if needed
              if (!this.mod.chooseDraftOverlay) {
                ChooseDraftOverlay = require('./overlay/choose-draft');
                this.mod.chooseDraftOverlay = new ChooseDraftOverlay(this.app, this.mod);
              }

              // Small delay to ensure editor is fully rendered behind overlay
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this3.mod.chooseDraftOverlay.render();
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })), 100);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function showDraftChooserOverlay() {
        return _showDraftChooserOverlay.apply(this, arguments);
      }
      return showDraftChooserOverlay;
    }()
    /**
     * ========================================================================
     * LIFECYCLE: RESET SESSION STATE
     * ========================================================================
     *
     * Resets ALL session-local state for a fresh editing session.
     * Called at the start of render() to ensure clean state regardless of:
     * - prior navigation
     * - prior publish
     * - crash recovery
     * - draft chooser re-entry
     *
     * DO NOT rely on constructor defaults - CreatePost is long-lived.
     */
  }, {
    key: "resetSessionState",
    value: function resetSessionState() {
      // ========================================================================
      // TEMP: Log session reset for validation
      // ========================================================================
      console.debug('[TEMP] CreatePost: resetSessionState() called - starting fresh session');

      // Publishing state - MUST be reset (publish must not poison future sessions)
      this.isPublished = false;
      this.draftTransaction = null;
      this.sessionIntent = null;
      this.activeDraftId = null;

      // Drag/drop state
      this.isDragging = false;
      this.storedDropRange = null;
      this.storedInsertionPoint = null;

      // Timer state - cancel any existing timers (defensive)
      if (this.serializeTimeout) {
        clearTimeout(this.serializeTimeout);
        this.serializeTimeout = null;
      }
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout);
        this.inactivityTimeout = null;
      }
      if (this.editingTimer) {
        clearTimeout(this.editingTimer);
        this.editingTimer = null;
      }
      if (this.saveStateTimeout) {
        clearTimeout(this.saveStateTimeout);
        this.saveStateTimeout = null;
      }

      // Editing/saving state
      this.editingStartTime = null;
      this.lastSaveContent = null;
      this.lastTrackedContent = null;
      this.changedBytes = 0;
      this.isSaving = false;
      this.queuedSave = false;
      this.isComposing = false;
      this.saveState = 'draft';
      this.savingStartTime = null;

      // Event listener attachment flag (prevents double attachment)
      this.eventsAttached = false;
    }

    /**
     * ========================================================================
     * LIFECYCLE: MOUNT BOUNDARY
     * ========================================================================
     *
     * "Mounted" means all three required elements exist:
     * - .saito-container exists
     * - #stack-post-body-editor exists
     * - #stack-post-title-input exists
     *
     * Mount verification must happen BEFORE attaching event listeners.
     */
  }, {
    key: "isEditorMounted",
    value: function isEditorMounted() {
      var container = document.querySelector(this.container || '.saito-container');
      var editor = document.querySelector('#stack-post-body-editor');
      var titleInput = document.querySelector('#stack-post-title-input');
      return !!(container && editor && titleInput);
    }

    /**
     * ========================================================================
     * INVARIANT ASSERTIONS: Defensive hardening helpers
     * ========================================================================
     *
     * These helpers detect invariant violations early and fail loudly.
     * They prevent silent bugs and make refactoring safer.
     */

    /**
     * Assert that editor is mounted
     * Fails loudly if editor DOM elements are missing
     */
  }, {
    key: "assertEditorMounted",
    value: function assertEditorMounted() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.isEditorMounted()) {
        var msg = "[EDITOR-INVARIANT] Editor must be mounted".concat(context ? " (".concat(context, ")") : '');
        console.error(msg);
        throw new Error(msg);
      }
    }

    /**
     * Assert that session intent is valid
     * Fails loudly if sessionIntent is missing or invalid
     */
  }, {
    key: "assertValidSessionIntent",
    value: function assertValidSessionIntent() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.sessionIntent) {
        var msg = "[EDITOR-INVARIANT] sessionIntent must be defined".concat(context ? " (".concat(context, ")") : '');
        console.error(msg);
        throw new Error(msg);
      }
      var validModes = ['new', 'resume', 'select'];
      if (!validModes.includes(this.sessionIntent.mode)) {
        var _msg = "[EDITOR-INVARIANT] Invalid sessionIntent.mode: ".concat(this.sessionIntent.mode).concat(context ? " (".concat(context, ")") : '');
        console.error(_msg);
        throw new Error(_msg);
      }

      // If mode is 'resume' or 'select', draftId must be present
      if ((this.sessionIntent.mode === 'resume' || this.sessionIntent.mode === 'select') && !this.sessionIntent.draftId) {
        var _msg2 = "[EDITOR-INVARIANT] sessionIntent.draftId required for mode '".concat(this.sessionIntent.mode, "'").concat(context ? " (".concat(context, ")") : '');
        console.error(_msg2);
        throw new Error(_msg2);
      }
    }

    /**
     * Assert that active draft ID is consistent with session intent
     * Fails loudly if activeDraftId state is invalid
     */
  }, {
    key: "assertActiveDraftConsistency",
    value: function assertActiveDraftConsistency() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.sessionIntent) {
        // No intent means no active session - skip check
        return;
      }
      if (this.sessionIntent.mode === 'new') {
        // New sessions should have activeDraftId = null initially
        // (draft created lazily on first edit)
        if (this.activeDraftId !== null && this.draftTransaction === null) {
          var msg = "[EDITOR-INVARIANT] activeDraftId should be null for 'new' session without draftTransaction".concat(context ? " (".concat(context, ")") : '');
          console.error(msg);
          // Don't throw - this can happen legitimately after first save
        }
      } else if (this.sessionIntent.mode === 'resume' || this.sessionIntent.mode === 'select') {
        // Resume/select sessions must have activeDraftId matching sessionIntent.draftId
        if (this.activeDraftId !== this.sessionIntent.draftId) {
          var _msg3 = "[EDITOR-INVARIANT] activeDraftId (".concat(this.activeDraftId, ") must match sessionIntent.draftId (").concat(this.sessionIntent.draftId, ")").concat(context ? " (".concat(context, ")") : '');
          console.error(_msg3);
          // Don't throw - this can be set during draft loading
        }
      }
    }

    /**
     * ========================================================================
     * LIFECYCLE: EDITOR MOUNT
     * ========================================================================
     *
     * Called after DOM is ready and initializeDocument() has completed.
     * Verifies mount boundary, then attaches event listeners exactly once.
     *
     * This ensures event listeners are only attached when editor is fully ready
     * and prevents double attachment.
     */
  }, {
    key: "onEditorMount",
    value: function onEditorMount() {
      var _this4 = this;
      // ========================================================================
      // TEMP: Log mount attempt for validation
      // ========================================================================
      console.debug('[TEMP] CreatePost: onEditorMount() called');

      // Verify mount boundary before proceeding
      if (!this.isEditorMounted()) {
        console.error('Stack: onEditorMount() called but editor is not mounted. Required elements missing.');
        // Retry after a short delay (DOM might not be ready yet)
        setTimeout(function () {
          if (_this4.isEditorMounted()) {
            _this4.onEditorMount();
          } else {
            console.error('Stack: Editor mount failed after retry. Editor elements still missing.');
          }
        }, 50);
        return;
      }

      // ========================================================================
      // INVARIANT CHECK: Guard against double attachment
      // ========================================================================
      if (this.eventsAttached) {
        console.warn('[EDITOR-INVARIANT] onEditorMount() called but events already attached. Skipping.');
        return;
      }

      // ========================================================================
      // [EDITOR-INVARIANT] Log successful mount for validation
      // ========================================================================
      console.debug('[EDITOR-INVARIANT] Mount verified, attaching event listeners');

      // Normalize DOM: blockquote must never be a child of <ul>
      this._ensureBlockquoteNotInList();

      // Mount verified - attach event listeners exactly once
      this.attachEvents();
      this.eventsAttached = true;

      // ========================================================================
      // [EDITOR-INVARIANT] Log mount completion for validation
      // ========================================================================
      console.debug('[EDITOR-INVARIANT] Mount complete, event listeners attached');
    }

    /**
     * ========================================================================
     * LIFECYCLE: EDITOR UNMOUNT
     * ========================================================================
     *
     * Called before navigating away from the editor.
     * Cancels all timers and cleans up state to prevent leaks.
     *
     * Must be called before:
     * - Navigating to splash
     * - Navigating to viewer
     * - Navigating to explore
     * - Re-entering editor (another render() call)
     */
  }, {
    key: "onEditorUnmount",
    value: function onEditorUnmount() {
      // Cancel all timers
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout);
        this.inactivityTimeout = null;
      }
      if (this.serializeTimeout) {
        clearTimeout(this.serializeTimeout);
        this.serializeTimeout = null;
      }
      if (this.saveStateTimeout) {
        clearTimeout(this.saveStateTimeout);
        this.saveStateTimeout = null;
      }
      if (this.editingTimer) {
        clearTimeout(this.editingTimer);
        this.editingTimer = null;
      }

      // Reset editing state
      this.editingStartTime = null;
      this.queuedSave = false;
      this.isComposing = false;
      this.savingStartTime = null; // Reset saving start time on unmount

      // Reset event attachment flag so events can be re-attached on next mount
      this.eventsAttached = false;

      // Note: We do NOT reset isPublished or draftTransaction here
      // Those are reset in resetSessionState() at the start of render() to ensure fresh session state
    }

    /**
     * Serialize DOM directly to markdown
     * DOM is the single source of truth during editing
     *
     * PUBLISH-TIME INVARIANT: This method reads directly from the live DOM.
     * It does NOT use cached state, draft snapshots, or autosave output.
     * What the user sees in the editor is exactly what gets serialized.
     */
    /**
     * DOM repair: blockquote must never be a child of <ul>.
     * Move any blockquote found inside a list to be a sibling after the list.
     */
  }, {
    key: "_ensureBlockquoteNotInList",
    value: function _ensureBlockquoteNotInList() {
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return;
      var uls = editor.querySelectorAll('ul');
      var _iterator = _createForOfIteratorHelper(uls),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ul = _step.value;
          var blockquotes = Array.from(ul.children).filter(function (n) {
            return n.tagName === 'BLOCKQUOTE' && n.hasAttribute('data-block-id');
          });
          var _iterator2 = _createForOfIteratorHelper(blockquotes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var bq = _step2.value;
              var editorParent = ul.parentNode;
              ul.removeChild(bq);
              if (ul.nextSibling) {
                editorParent.insertBefore(bq, ul.nextSibling);
              } else {
                editorParent.appendChild(bq);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * Parse markdown string into editor block elements (with data-block-id, data-block-type).
     * Ensures block structure round-trips: paste -> serialize -> reload -> identical structure.
     * @param {string} markdown - Markdown content to parse
     * @param {{ blockIndex: number }} state - Optional; mutated blockIndex for unique IDs across multiple calls
     */
  }, {
    key: "_parseMarkdownToBlockElements",
    value: function _parseMarkdownToBlockElements(markdown) {
      var _this5 = this;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        blockIndex: 0
      };
      var elements = [];
      var lines = (markdown || '').split(/\n/);
      var i = 0;
      var nextId = function nextId() {
        return generateBlockId(state.blockIndex++, 'block');
      };
      var _loop = function _loop() {
          var line = lines[i];
          var trimmed = line.trim();
          if (trimmed === '') {
            i++;
            return 0; // continue
          }
          var headingMatch = trimmed.match(/^(#{1,6})\s+(.+)$/);
          if (headingMatch) {
            var level = headingMatch[1].length;
            var text = headingMatch[2].trim();
            var el = document.createElement("h".concat(level));
            el.setAttribute('data-block-id', nextId());
            el.setAttribute('data-block-type', 'heading');
            el.textContent = text;
            el.contentEditable = 'true';
            elements.push(el);
            i++;
            return 0; // continue
          }
          var unorderedMatch = trimmed.match(/^([*\-+])\s+(.*)$/);
          var orderedMatch = trimmed.match(/^(\d+)([.)])\s+(.*)$/);
          var listMatch = unorderedMatch || orderedMatch;
          if (listMatch) {
            var ul = document.createElement('ul');
            while (i < lines.length) {
              var liLine = lines[i];
              var liTrimmed = liLine.trim();
              var liUnordered = liTrimmed.match(/^([*\-+])\s+(.*)$/);
              var liOrdered = liTrimmed.match(/^(\d+)([.)])\s+(.*)$/);
              var liMatch = liUnordered || liOrdered;
              if (!liMatch) break;
              var liMarker = liUnordered ? liUnordered[1] + ' ' : liOrdered[1] + liOrdered[2] + ' ';
              var liText = (liUnordered ? liUnordered[2] : liOrdered[3]) || '';
              var li = document.createElement('li');
              li.setAttribute('data-block-id', nextId());
              li.setAttribute('data-block-type', 'list-item');
              li.setAttribute('data-list-marker', liMarker);
              li.textContent = liText;
              li.contentEditable = 'true';
              ul.appendChild(li);
              i++;
            }
            elements.push(ul);
            return 0; // continue
          }
          if (trimmed.startsWith('> ')) {
            var bqLines = [];
            while (i < lines.length && lines[i].trimStart().startsWith('>')) {
              bqLines.push(lines[i].replace(/^>\s?/, ''));
              i++;
            }
            var bq = document.createElement('blockquote');
            bq.setAttribute('data-block-id', nextId());
            bq.setAttribute('data-block-type', 'blockquote');
            bq.textContent = bqLines.join('\n').replace(/\u200B/g, '').trim();
            bq.contentEditable = 'true';
            elements.push(bq);
            return 0; // continue
          }
          if (trimmed === '```') {
            var codeLines = [];
            i++;
            while (i < lines.length && lines[i].trim() !== '```') {
              codeLines.push(lines[i]);
              i++;
            }
            if (i < lines.length) i++;
            var pre = document.createElement('pre');
            pre.setAttribute('data-block-id', nextId());
            pre.setAttribute('data-block-type', 'code');
            pre.textContent = codeLines.join('\n');
            pre.contentEditable = 'true';
            elements.push(pre);
            return 0; // continue
          }
          var imageMatch = trimmed.match(/^!\[([^\]]*)\]\((stack:image:[^)]+)\)$/);
          if (imageMatch && _this5.images && _this5.images.length > 0) {
            var imageId = imageMatch[2].replace('stack:image:', '');
            var imgData = _this5.images.find(function (im) {
              return im.id === imageId;
            });
            if (imgData) {
              var figure = document.createElement('figure');
              figure.setAttribute('data-block-id', nextId());
              figure.setAttribute('data-block-type', 'image');
              figure.className = 'image-block';
              var img = document.createElement('img');
              img.src = "data:".concat(imgData.mime, ";base64,").concat(imgData.data);
              img.dataset.stackImageId = imgData.id;
              img.alt = imageMatch[1] || '';
              figure.appendChild(img);
              elements.push(figure);
              i++;
              return 0; // continue
            }
          }
          var paraLines = [];
          while (i < lines.length) {
            var pl = lines[i];
            if (pl.trim() === '') break;
            if (/^#{1,6}\s/.test(pl.trim()) || /^[*\-+]\s/.test(pl.trim()) || /^\d+[.)]\s/.test(pl.trim()) || pl.trimStart().startsWith('>') || pl.trim() === '```') break;
            paraLines.push(pl);
            i++;
          }
          var p = document.createElement('p');
          p.setAttribute('data-block-id', nextId());
          p.setAttribute('data-block-type', 'paragraph');
          var paraText = paraLines.join('\n').replace(/\u200B/g, '').trim();
          if (paraText) {
            p.textContent = paraText;
          } else {
            p.appendChild(document.createTextNode("\u200B"));
          }
          p.contentEditable = 'true';
          elements.push(p);
        },
        _ret;
      while (i < lines.length) {
        _ret = _loop();
        if (_ret === 0) continue;
      }
      return elements;
    }

    /**
     * Serialize inline content from a container, treating <code> and <pre> as opaque.
     * No linkification, emphasis parsing, or any transformation of code content.
     */
  }, {
    key: "_serializeInlineContent",
    value: function _serializeInlineContent(container) {
      if (!container) return '';
      var out = '';
      var _iterator3 = _createForOfIteratorHelper(container.childNodes),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var node = _step3.value;
          if (node.nodeType === Node.TEXT_NODE) {
            out += (node.textContent || '').replace(/\u200B/g, '');
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            var tag = node.tagName ? node.tagName.toLowerCase() : '';
            if (tag === 'code') {
              out += '`' + (node.textContent || '').replace(/\u200B/g, '') + '`';
            } else if (tag === 'pre') {
              out += (node.textContent || '').replace(/\u200B/g, '');
            } else if (tag === 'br') {
              out += '  \n';
            } else {
              out += this._serializeInlineContent(node);
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return out;
    }
  }, {
    key: "serializeDOMToMarkdown",
    value: function serializeDOMToMarkdown() {
      var imageIdMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // PUBLISH MODE: build imageIdMap if not provided
      if (imageIdMap === null) {
        imageIdMap = new Map();
      }
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) {
        return '';
      }
      var markdownLines = [];
      var blockElements = Array.from(editor.querySelectorAll('[data-block-id]'));
      for (var i = 0; i < blockElements.length; i++) {
        var blockEl = blockElements[i];
        var blockType = blockEl.getAttribute('data-block-type');

        // Add blank line between blocks (except before first block)
        if (i > 0) {
          markdownLines.push('');
        }
        switch (blockType) {
          case 'heading':
            {
              var level = parseInt(blockEl.tagName.charAt(1)) || 1;
              var headingText = this._serializeInlineContent(blockEl).replace(/\u200B/g, '').trim();
              var headingPrefix = '#'.repeat(level);
              markdownLines.push("".concat(headingPrefix, " ").concat(headingText));
              break;
            }
          case 'image':
            {
              var img = blockEl.querySelector('img');
              var captionEl = blockEl.querySelector('.image-caption');
              var alt = captionEl ? captionEl.textContent : '';
              if (!img) break;
              var imageId = img.dataset.stackImageId;
              if (!imageId) {
                throw new Error('serializeDOMToMarkdown: image missing stackImageId');
              }
              markdownLines.push("![".concat(alt, "](stack:image:").concat(imageId, ")"));
              break;
            }
          case 'code':
            // Code blocks: <pre> with data-block-type="code"
            // Serialize as markdown code fence (```)
            var codeText = (blockEl.textContent || '').replace(/\u200B/g, '');
            markdownLines.push('```');
            markdownLines.push(codeText);
            markdownLines.push('```');
            break;
          case 'rawhtml':
            var htmlContent = blockEl.innerHTML || '';
            markdownLines.push(htmlContent);
            break;
          case 'list-item':
            {
              var text = this._serializeInlineContent(blockEl).replace(/\u200B/g, '').trim();
              if (text) {
                var marker = blockEl.getAttribute('data-list-marker') || '- ';
                markdownLines.push("".concat(marker).concat(text));
              }
              break;
            }
          case 'blockquote':
            {
              // Blockquote: emit "> " prefix per line so structure round-trips
              var rawText = this._serializeInlineContent(blockEl).replace(/\u200B/g, '');
              var lines = rawText.split(/\n/);
              var blockquoteLines = lines.map(function (line) {
                return '> ' + (line || '');
              });
              markdownLines.push(blockquoteLines.join('\n'));
              break;
            }
          case 'paragraph':
          default:
            {
              // Paragraph: serialize inline content; <code>/<pre> are opaque
              var _text = this._serializeInlineContent(blockEl).replace(/\u200B/g, '').trim();
              if (_text) {
                markdownLines.push(_text);
              }
              break;
            }
        }
      }
      return markdownLines.join('\n');
    }

    /**
     * Check if editor has meaningful content and update placeholder visibility
     * Reads directly from DOM (single source of truth)
     */
  }, {
    key: "updatePlaceholderVisibility",
    value: function updatePlaceholderVisibility() {
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return;

      // Check if there's any meaningful content (read from DOM)
      var blockElements = editor.querySelectorAll('[data-block-id]');
      var hasContent = false;
      var _iterator4 = _createForOfIteratorHelper(blockElements),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var blockEl = _step4.value;
          var blockType = blockEl.getAttribute('data-block-type');
          if (blockType === 'paragraph' || blockType === 'heading' || blockType === 'list-item' || blockType === 'blockquote') {
            var text = (blockEl.textContent || '').replace(/\u200B/g, '').trim();
            if (text.length > 0) {
              hasContent = true;
              break;
            }
          } else if (blockType === 'image') {
            hasContent = true; // Images count as content
            break;
          } else if (blockType === 'rawhtml') {
            var html = (blockEl.innerHTML || '').trim();
            if (html.length > 0) {
              hasContent = true;
              break;
            }
          }
        }

        // Toggle placeholder class
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      if (hasContent) {
        editor.classList.remove('empty');
      } else {
        editor.classList.add('empty');
      }
    }

    /**
     * Schedule debounced serialization with configurable thresholds
     * Serializes directly from DOM (single source of truth)
     *
     * Save triggers when ANY of:
     * 1) User stops editing for save_after_inactivity ms
     * 2) Total changed characters >= save_after_bytes
     * 3) Continuous editing time >= save_after_editing ms
     *
     * Additional rules:
     * - Only ONE save may be in-flight at a time
     * - If editor becomes dirty during save, queue ONE follow-up save
     * - Do NOT save during IME composition
     * - Do NOT save during publish flow
     */
  }, {
    key: "scheduleSerialization",
    value: function scheduleSerialization() {
      var _this6 = this;
      // Skip if published, composing, or during publish flow
      if (this.isPublished || this.isComposing) {
        return;
      }

      // Get current content to track changes
      var currentContent = this.serializeDOMToMarkdown();
      var title = this.getDocumentTitle();
      var fullContent = title + currentContent;

      // Calculate bytes changed since last save (incremental tracking)
      if (this.lastTrackedContent !== null) {
        // Track incremental change from last call to scheduleSerialization
        var lastLength = this.lastTrackedContent.length;
        var currentLength = fullContent.length;
        var delta = Math.abs(currentLength - lastLength);
        this.changedBytes += delta;
      } else if (this.lastSaveContent !== null) {
        // First call after a save - compare to last saved content
        var _lastLength = this.lastSaveContent.length;
        var _currentLength = fullContent.length;
        var _delta = Math.abs(_currentLength - _lastLength);
        this.changedBytes = _delta;
      } else {
        // First time ever - don't count initial content as "changed"
        this.changedBytes = 0;
      }

      // Update tracked content for next comparison
      this.lastTrackedContent = fullContent;

      // Start editing timer if not already started
      if (this.editingStartTime === null) {
        this.editingStartTime = Date.now();
      }

      // Check if we should save immediately (bytes threshold)
      if (this.changedBytes >= this.save_after_bytes) {
        this.triggerSave();
        return;
      }

      // Check if we should save due to continuous editing time
      if (this.editingStartTime !== null) {
        var editingDuration = Date.now() - this.editingStartTime;
        if (editingDuration >= this.save_after_editing) {
          this.triggerSave();
          return;
        }
      }

      // Clear existing inactivity timeout
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout);
      }

      // Schedule save after inactivity period
      this.inactivityTimeout = setTimeout(function () {
        _this6.triggerSave();
      }, this.save_after_inactivity);
    }

    /**
     * Trigger save operation
     * Ensures only one save in-flight, queues follow-up if needed
     *
     * INVARIANT: During normal typing, isEditorMounted() MUST be true.
     * If false, that indicates a lifecycle bug - log it and abort.
     */
  }, {
    key: "triggerSave",
    value: function () {
      var _triggerSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this7 = this;
        var currentContent, title, elapsed, minVisibilityMs, remainingTime, _elapsed, _minVisibilityMs, _remainingTime, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              // ========================================================================
              // [EDITOR-INVARIANT] Log autosave start for validation
              // ========================================================================
              console.debug('[EDITOR-INVARIANT] Autosave started');

              // ========================================================================
              // INVARIANT CHECK: Editor must be mounted
              // ========================================================================
              if (this.isEditorMounted()) {
                _context4.n = 1;
                break;
              }
              console.error('[EDITOR-INVARIANT] triggerSave() called but editor is not mounted. Aborting save.');
              return _context4.a(2);
            case 1:
              if (this.sessionIntent) {
                _context4.n = 2;
                break;
              }
              console.error('[EDITOR-INVARIANT] triggerSave() called without sessionIntent. Aborting save.');
              return _context4.a(2);
            case 2:
              if (!this.isPublished) {
                _context4.n = 3;
                break;
              }
              console.error('[EDITOR-INVARIANT] triggerSave() called after publish. Autosave must not run. Aborting save.');
              return _context4.a(2);
            case 3:
              // ========================================================================
              // INVARIANT CHECK: Active draft consistency (for resume/select sessions)
              // ========================================================================
              if (this.sessionIntent.mode !== 'new') {
                // For resume/select sessions, activeDraftId should match sessionIntent.draftId
                if (this.activeDraftId !== this.sessionIntent.draftId) {
                  console.error('[EDITOR-INVARIANT] triggerSave() called with mismatched activeDraftId. Expected:', this.sessionIntent.draftId, 'Got:', this.activeDraftId);
                  // Continue - draft may be in loading state
                }
              }

              // If save is already in progress, queue a follow-up
              if (!this.isSaving) {
                _context4.n = 4;
                break;
              }
              this.queuedSave = true;
              return _context4.a(2);
            case 4:
              // Mark as saving and record start time (for minimum visibility guarantee)
              this.isSaving = true;
              this.savingStartTime = Date.now();
              this.updateSaveState('saving');

              // Clear all timers
              if (this.inactivityTimeout) {
                clearTimeout(this.inactivityTimeout);
                this.inactivityTimeout = null;
              }
              if (this.serializeTimeout) {
                clearTimeout(this.serializeTimeout);
                this.serializeTimeout = null;
              }
              _context4.p = 5;
              _context4.n = 6;
              return this.saveDraftTransaction();
            case 6:
              // Update last saved content
              currentContent = this.serializeDOMToMarkdown();
              title = this.getDocumentTitle();
              this.lastSaveContent = title + currentContent;
              this.lastTrackedContent = this.lastSaveContent; // Reset tracked content to saved content

              // Reset change tracking
              this.changedBytes = 0;
              this.editingStartTime = null;

              // ========================================================================
              // GUARANTEE: Minimum 500ms "Saving…" visibility
              // ========================================================================
              // Calculate how long we've been showing "Saving…"
              elapsed = Date.now() - this.savingStartTime;
              minVisibilityMs = 500;
              remainingTime = Math.max(0, minVisibilityMs - elapsed); // Update state to "Saved" after minimum "Saving…" visibility
              if (this.saveStateTimeout) {
                clearTimeout(this.saveStateTimeout);
              }
              this.saveStateTimeout = setTimeout(function () {
                _this7.updateSaveState('saved');
                _this7.savingStartTime = null;
              }, remainingTime);

              // Check if a save was queued while we were saving
              if (this.queuedSave) {
                this.queuedSave = false;
                // Schedule another save if content changed during save
                this.scheduleSerialization();
              }
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t = _context4.v;
              console.error('Stack: Error saving draft:', _t);
              // On error, still enforce minimum visibility before showing "Draft"
              _elapsed = Date.now() - (this.savingStartTime || Date.now());
              _minVisibilityMs = 500;
              _remainingTime = Math.max(0, _minVisibilityMs - _elapsed);
              if (this.saveStateTimeout) {
                clearTimeout(this.saveStateTimeout);
              }
              this.saveStateTimeout = setTimeout(function () {
                _this7.updateSaveState('draft');
                _this7.savingStartTime = null;
              }, _remainingTime);
            case 8:
              _context4.p = 8;
              this.isSaving = false;
              return _context4.f(8);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[5, 7, 8, 9]]);
      }));
      function triggerSave() {
        return _triggerSave.apply(this, arguments);
      }
      return triggerSave;
    }()
    /**
     * Initialize empty editor (no draft loaded)
     * Called when session intent mode is 'new'
     * Draft transaction will be created lazily on first edit via triggerSave()
     */
  }, {
    key: "initializeEmptyEditor",
    value: function initializeEmptyEditor() {
      var editor = document.querySelector('#stack-post-body-editor');
      var titleInput = document.querySelector('#stack-post-title-input');
      if (!editor || !titleInput) return;
      this.setDocumentTitle('');

      // Create empty document
      var tempDocument = {
        blocks: [{
          type: 'paragraph',
          id: generateBlockId(0),
          text: ''
        }]
      };
      renderDocument(tempDocument, editor, {
        contentEditable: true
      });

      // Clear draft transaction reference (new draft, no transaction yet)
      this.draftTransaction = null;

      // Update UI state
      this.updatePlaceholderVisibility();
      this.updatePublishTriggerVisibility();
      this.updatePublishTriggerState();
      this.updateSaveState('draft');
    }

    /**
     * Title field helpers — empty documents show muted "Untitled" as a document
     * value (not instructional form copy). Persistence treats it as empty.
     */
  }, {
    key: "getTitleField",
    value: function getTitleField() {
      return document.querySelector('#stack-post-title-input');
    }
  }, {
    key: "isUntitledPlaceholder",
    value: function isUntitledPlaceholder() {
      var titleInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getTitleField();
      return !!(titleInput && titleInput.classList.contains('is-empty'));
    }
  }, {
    key: "getDocumentTitle",
    value: function getDocumentTitle() {
      var titleInput = this.getTitleField();
      if (!titleInput || this.isUntitledPlaceholder(titleInput)) {
        return '';
      }
      return (titleInput.value || '').trim();
    }
  }, {
    key: "syncTitleFieldHeight",
    value: function syncTitleFieldHeight() {
      var titleInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getTitleField();
      if (!titleInput) return;
      titleInput.style.height = 'auto';
      titleInput.style.height = "".concat(titleInput.scrollHeight, "px");
    }
  }, {
    key: "setDocumentTitle",
    value: function setDocumentTitle(title) {
      var titleInput = this.getTitleField();
      if (!titleInput) return;
      var trimmed = (title || '').trim();
      if (!trimmed) {
        titleInput.value = 'Untitled';
        titleInput.classList.add('is-empty');
      } else {
        titleInput.value = trimmed;
        titleInput.classList.remove('is-empty');
      }
      this.syncTitleFieldHeight(titleInput);
    }

    /**
     * @deprecated Use initializeEmptyEditor() instead. Kept for backward compatibility with chooser.
     */
  }, {
    key: "createNewDraft",
    value: function createNewDraft() {
      this.initializeEmptyEditor();
    }

    /**
     * Load the most recent draft from localhost archive
     * Queries for field4 = "stack:draft", sorts by updated_at DESC, loads the first result
     */
  }, {
    key: "loadMostRecentDraft",
    value: function () {
      var _loadMostRecentDraft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this8 = this;
        var _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              return _context5.a(2, new Promise(function (resolve) {
                _this8.app.storage.loadTransactions({
                  field1: 'Stack',
                  field4: 'stack:draft',
                  limit: 100 // Load up to 100 drafts to sort
                }, function (txs) {
                  if (!txs || txs.length === 0) {
                    resolve(null);
                    return;
                  }

                  // Sort by updated_at DESC (most recent first)
                  // Use tx.optional.updated_at if available, fallback to tx.timestamp
                  txs.sort(function (a, b) {
                    var _a$optional, _b$optional;
                    var aTime = ((_a$optional = a.optional) === null || _a$optional === void 0 ? void 0 : _a$optional.updated_at) || a.timestamp || 0;
                    var bTime = ((_b$optional = b.optional) === null || _b$optional === void 0 ? void 0 : _b$optional.updated_at) || b.timestamp || 0;
                    return bTime - aTime; // DESC order
                  });

                  // Get the most recent draft (first in sorted array)
                  var mostRecentDraft = txs[0];
                  if (!mostRecentDraft) {
                    resolve(null);
                    return;
                  }

                  // Load the draft
                  _this8.loadDraftTransaction(mostRecentDraft);
                  resolve(mostRecentDraft);
                }, 'localhost' // Query localhost archive only
                );
              }));
            case 1:
              _context5.p = 1;
              _t2 = _context5.v;
              console.error('Error loading draft:', _t2);
              return _context5.a(2, null);
          }
        }, _callee5, null, [[0, 1]]);
      }));
      function loadMostRecentDraft() {
        return _loadMostRecentDraft.apply(this, arguments);
      }
      return loadMostRecentDraft;
    }()
    /**
     * Load a draft by ID (signature or hash)
     * Queries for the specific draft transaction and loads it into the editor
     */
  }, {
    key: "loadDraftById",
    value: function () {
      var _loadDraftById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(draftId) {
        var _this9 = this;
        var _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              return _context6.a(2, new Promise(function (resolve) {
                _this9.app.storage.loadTransactions({
                  field1: 'Stack',
                  field4: 'stack:draft',
                  limit: 100 // Load up to 100 drafts to search
                }, function (txs) {
                  if (!txs || txs.length === 0) {
                    resolve(null);
                    return;
                  }

                  // Find transaction by signature or hash
                  var draft = txs.find(function (t) {
                    return t.signature === draftId || t.hash === draftId;
                  });
                  if (!draft) {
                    resolve(null);
                    return;
                  }

                  // Load the draft
                  _this9.loadDraftTransaction(draft);
                  resolve(draft);
                }, 'localhost' // Query localhost archive only
                );
              }));
            case 1:
              _context6.p = 1;
              _t3 = _context6.v;
              console.error('Error loading draft by ID:', _t3);
              return _context6.a(2, null);
          }
        }, _callee6, null, [[0, 1]]);
      }));
      function loadDraftById(_x2) {
        return _loadDraftById.apply(this, arguments);
      }
      return loadDraftById;
    }()
    /**
     * Internal helper to load a draft transaction into the editor
     * Populates title, content, and featured image from the transaction
     *
     * IMPORTANT: Clones transaction data to prevent shared reference bugs.
     * Archived drafts are treated as immutable snapshots. Editor mutations
     * must not affect the stored draft until explicitly saved.
     */
  }, {
    key: "loadDraftTransaction",
    value: function loadDraftTransaction(tx) {
      var _this0 = this;
      // Extract data from transaction
      var msg = tx.returnMessage();
      var data = (msg === null || msg === void 0 ? void 0 : msg.data) || {};

      // ========================================================================
      // CLONE DATA: Deep clone to prevent shared reference mutations
      // ========================================================================
      // When loading a draft, we must clone the transaction data to ensure
      // that editing one draft doesn't mutate other drafts that share the
      // same underlying transaction object reference.
      var clonedData = JSON.parse(JSON.stringify(data));
      var title = clonedData.title || '';
      var content = clonedData.content || '';

      // Populate title field
      this.setDocumentTitle(title);

      // Populate body editor
      var editor = document.querySelector('#stack-post-body-editor');
      if (editor) {
        if (content.trim()) {
          // ----------------------------------------------------
          // EDIT MODE RENDERING (markdown + images)
          // Parse markdown into block structure so paste->save->reload round-trips exactly
          // ----------------------------------------------------

          editor.innerHTML = '';
          this.images = Array.isArray(clonedData.images) ? _toConsumableArray(clonedData.images) : [];
          var parts = content.split(/!\[([^\]]*)\]\(stack:image:([^)]+)\)/g);
          var blockState = {
            blockIndex: 0
          };
          var nextBlockId = function nextBlockId() {
            return generateBlockId(blockState.blockIndex++, 'block');
          };
          var _loop2 = function _loop2() {
            if (i % 3 === 0 && parts[i]) {
              var blockEls = _this0._parseMarkdownToBlockElements(parts[i], blockState);
              blockEls.forEach(function (el) {
                return editor.appendChild(el);
              });
            }
            if (i % 3 === 2) {
              var imageId = parts[i];
              var image = _this0.images.find(function (img) {
                return img.id === imageId;
              });
              if (!image) return 1; // continue
              var figure = document.createElement('figure');
              figure.setAttribute('data-block-id', nextBlockId());
              figure.setAttribute('data-block-type', 'image');
              figure.className = 'image-block';
              var img = document.createElement('img');
              img.src = "data:".concat(image.mime, ";base64,").concat(image.data);
              img.dataset.stackImageId = image.id;
              img.alt = parts[i - 1] || '';
              figure.appendChild(img);
              editor.appendChild(figure);
            }
          };
          for (var i = 0; i < parts.length; i++) {
            if (_loop2()) continue;
          }
          if (editor.children.length === 0) {
            var p = document.createElement('p');
            p.setAttribute('data-block-id', generateBlockId(blockState.blockIndex++, 'block'));
            p.setAttribute('data-block-type', 'paragraph');
            p.appendChild(document.createTextNode("\u200B"));
            p.contentEditable = 'true';
            editor.appendChild(p);
          }
        } else {
          // Empty content - render empty document
          var tempDocument = {
            blocks: [{
              type: 'paragraph',
              id: generateBlockId(0),
              text: ''
            }]
          };
          renderDocument(tempDocument, editor, {
            contentEditable: true
          });
        }
      }

      // ========================================================================
      // STORE CLONED TRANSACTION: Clone msg.data to prevent shared reference mutations
      // ========================================================================
      // When loading a draft, we clone the transaction's message data to ensure
      // that editing one draft doesn't mutate other drafts that share the same
      // underlying transaction object reference. We create a shallow copy of the
      // transaction (preserving its prototype/methods) and replace msg with a
      // cloned version containing cloned data. Since we only mutate tx.msg during
      // saves, this ensures isolation - each draft has independent data.
      var clonedTx = Object.assign(Object.create(Object.getPrototypeOf(tx)), tx);
      if (msg) {
        clonedTx.msg = JSON.parse(JSON.stringify(msg));
        clonedTx.msg.data = clonedData;
      }
      this.draftTransaction = clonedTx;
      this.activeDraftId = tx.signature || tx.hash || null;

      // PART 4 — SAFETY CONSTRAINTS: Drafts NEVER set parent_id
      // Drafts ALWAYS show "Publish" button
      this.parent_id = null;

      // Load featured image from draft if present (use cloned data)
      if (clonedData.image) {
        this.featuredImage = clonedData.image; // Base64 data (from cloned data)
        // Update display after a short delay to ensure DOM is ready
        setTimeout(function () {
          _this0.updateFeaturedImageDisplay();
        }, 50);
      } else {
        this.featuredImage = null;
        this.updateFeaturedImageDisplay();
      }

      // ========================================================================
      // [EDITOR-INVARIANT] Log draft bind after loading for validation
      // ========================================================================
      console.debug('[EDITOR-INVARIANT] Draft loaded and bound:', this.activeDraftId);

      // Update UI state
      this.updatePlaceholderVisibility();
      this.updatePublishTriggerVisibility();
      this.updatePublishTriggerState();
      this.updateSaveState('draft');
    }

    /**
     * Save or update draft transaction to localhost archive
     * Drafts are unsigned transactions saved with field4 = "stack:draft"
     *
     * INVARIANT: This method must NEVER early-return due to stale state.
     * isPublished is ALWAYS false when entering the editor (reset in render()).
     * Publishing does NOT poison future editor sessions.
     */
  }, {
    key: "saveDraftTransaction",
    value: function () {
      var _saveDraftTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var title, content, tx, loadedDraft, data, field4Value, _tx$msg, _tx$msg2, _data, _field4Value, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              // ========================================================================
              // [EDITOR-INVARIANT] Log save attempt for validation
              // ========================================================================
              console.debug('[EDITOR-INVARIANT] saveDraftTransaction() called, activeDraftId:', this.activeDraftId);

              // ========================================================================
              // INVARIANT CHECK: Must not save after publish
              // ========================================================================
              if (!this.isPublished) {
                _context7.n = 1;
                break;
              }
              console.error('[EDITOR-INVARIANT] saveDraftTransaction() called with isPublished=true. Autosave must not run after publish.');
              return _context7.a(2);
            case 1:
              if (this.sessionIntent) {
                _context7.n = 2;
                break;
              }
              console.error('[EDITOR-INVARIANT] saveDraftTransaction() called without sessionIntent. Aborting save.');
              return _context7.a(2);
            case 2:
              _context7.p = 2;
              title = this.getDocumentTitle();
              content = this.serializeDOMToMarkdown(); // Skip if both title and content are empty
              if (!(!title.trim() && !content.trim())) {
                _context7.n = 3;
                break;
              }
              console.log('[DIAG] saveDraftTransaction() EARLY RETURN: title and content are both empty');
              return _context7.a(2);
            case 3:
              // Get current draft transaction or create new one
              // If activeDraftId is set, we must load that draft (session-scoped)
              tx = this.draftTransaction;
              if (!(!tx && this.activeDraftId)) {
                _context7.n = 5;
                break;
              }
              // Session has activeDraftId but no draftTransaction - load it
              console.log('[DIAG] saveDraftTransaction() Loading existing draft for activeDraftId:', this.activeDraftId);
              _context7.n = 4;
              return this.loadDraftById(this.activeDraftId);
            case 4:
              loadedDraft = _context7.v;
              if (loadedDraft) {
                tx = this.draftTransaction;
              }
            case 5:
              if (tx) {
                _context7.n = 8;
                break;
              }
              console.log('[DIAG] saveDraftTransaction() Creating NEW draft transaction');
              // Create new unsigned transaction
              _context7.n = 6;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.publicKey);
            case 6:
              tx = _context7.v;
              data = {
                type: 'stack_post',
                title: title.trim() || '',
                content: content.trim() || '',
                tags: [],
                image: this.featuredImage || '',
                imageUrl: '',
                images: Array.isArray(this.images) ? this.images : [],
                // ← FIX
                timestamp: Date.now(),
                subscriptionTier: 'free',
                excerpt: ''
              };
              tx.msg = {
                module: 'Stack',
                request: 'create stack post request',
                data: data
              };

              // ========================================================================
              // DIAGNOSTIC: Log field4 value being saved
              // ========================================================================
              field4Value = 'stack:draft';
              console.log('[DIAG] saveDraftTransaction() Saving NEW draft with field4 =', field4Value);

              // ========================================================================
              // DIAGNOSTIC: Log exact values being stored (field1, field2, field4, peer)
              // ========================================================================
              // console.log('[DIAG] saveDraftTransaction() About to save with:');
              // console.log('[DIAG]   - field1: (auto-populated from tx.msg.module, expected: "Stack")');
              // console.log('[DIAG]   - field2: (auto-populated from tx.from[0].publicKey, expected:', this.mod.publicKey, ')');
              // console.log('[DIAG]   - field4:', field4Value);
              // console.log('[DIAG]   - peer: "localhost"');
              // console.log('[DIAG]   - tx.msg.module =', JSON.stringify(tx.msg?.module), '(type:', typeof tx.msg?.module, ')');
              // console.log('[DIAG]   - tx.from =', tx.from ? JSON.stringify(tx.from) : 'N/A');
              // console.log('[DIAG]   - tx.from[0].publicKey =', tx.from && tx.from[0] ? JSON.stringify(tx.from[0].publicKey) : 'N/A');
              // console.log('[DIAG]   - tx.signature =', tx.signature || 'N/A (unsigned transaction - signature may be generated on save)');
              // console.log('[DIAG]   - this.mod.publicKey =', JSON.stringify(this.mod.publicKey));

              // Save new draft transaction (field1 is auto-populated from tx.msg.module)
              _context7.n = 7;
              return this.app.storage.saveTransaction(tx, {
                field4: field4Value
              }, 'localhost');
            case 7:
              // ========================================================================
              // DIAGNOSTIC: Confirmation that storage.saveTransaction() resolved
              // ========================================================================
              console.log('[DIAG] saveDraftTransaction() storage.saveTransaction() RESOLVED (new draft created)');
              console.log('[DIAG] saveDraftTransaction() After save, tx.signature =', tx.signature || 'N/A (still unsigned?)');

              // ========================================================================
              // DIAGNOSTIC: Immediately verify what was stored by querying back
              // ========================================================================
              // Try verification with signature first (if available)
              if (tx.signature) {
                console.log('[DIAG] saveDraftTransaction() Verifying saved draft by signature...');
                this.app.storage.loadTransactions({
                  field1: 'Stack',
                  field4: 'stack:draft',
                  signature: tx.signature
                }, function (verificationTxs) {
                  var verifyCount = verificationTxs ? verificationTxs.length : 0;
                  console.log('[DIAG] saveDraftTransaction() Verification query (by signature) found', verifyCount, 'matching transactions');
                  if (verifyCount > 0 && verificationTxs[0]) {
                    var verifyTx = verificationTxs[0];
                    console.log('[DIAG] saveDraftTransaction() Verified transaction has:');
                    console.log('[DIAG]   - field1:', JSON.stringify(verifyTx.field1 || 'N/A'));
                    console.log('[DIAG]   - field2:', JSON.stringify(verifyTx.field2 || 'N/A'));
                    console.log('[DIAG]   - field4:', JSON.stringify(verifyTx.field4 || 'N/A'));
                    console.log('[DIAG]   - signature:', verifyTx.signature || 'N/A');
                  } else {
                    console.log('[DIAG] saveDraftTransaction() WARNING: Verification query (by signature) found NO matching transactions!');
                  }
                }, 'localhost');
              } else {
                console.log('[DIAG] saveDraftTransaction() Transaction has no signature after save (unsigned transaction)');
              }

              // ========================================================================
              // DIAGNOSTIC: Also verify by field1 + field4 (same query as discoverDrafts)
              // ========================================================================
              console.log('[DIAG] saveDraftTransaction() Verifying saved draft using discoverDrafts() query pattern...');
              this.app.storage.loadTransactions({
                field1: 'Stack',
                field4: 'stack:draft'
              }, function (verificationTxs) {
                var verifyCount = verificationTxs ? verificationTxs.length : 0;
                console.log('[DIAG] saveDraftTransaction() Verification query (field1+field4) found', verifyCount, 'matching transactions');
                if (verifyCount > 0) {
                  console.log('[DIAG] saveDraftTransaction() All matching drafts:');
                  verificationTxs.forEach(function (verifyTx, idx) {
                    console.log("[DIAG]   Draft ".concat(idx + 1, ":"));
                    console.log("[DIAG]     - field1: ".concat(JSON.stringify(verifyTx.field1 || 'N/A')));
                    console.log("[DIAG]     - field2: ".concat(JSON.stringify(verifyTx.field2 || 'N/A')));
                    console.log("[DIAG]     - field4: ".concat(JSON.stringify(verifyTx.field4 || 'N/A')));
                    console.log("[DIAG]     - signature: ".concat(verifyTx.signature || 'N/A'));
                  });
                } else {
                  console.log('[DIAG] saveDraftTransaction() CRITICAL: Verification query (field1+field4) found NO matching transactions!');
                  console.log('[DIAG] saveDraftTransaction() This means the draft was NOT saved or was saved with different field values.');
                }
              }, 'localhost');

              // Log successful save (downgraded from diagnostic)
              console.debug('Stack: storage.saveTransaction() resolved (new draft created)');

              // Store reference for future updates and set active draft ID
              this.draftTransaction = tx;
              this.activeDraftId = tx.signature || tx.hash || null;

              // ========================================================================
              // [EDITOR-INVARIANT] Log new draft creation for validation
              // ========================================================================
              console.debug('[EDITOR-INVARIANT] New draft created and bound:', this.activeDraftId);
              _context7.n = 10;
              break;
            case 8:
              console.log('[DIAG] saveDraftTransaction() Updating EXISTING draft transaction (signature:', tx.signature || tx.hash, ')');
              // Update existing draft transaction
              _data = {
                type: 'stack_post',
                title: title.trim() || '',
                content: content.trim() || '',
                tags: [],
                image: this.featuredImage || '',
                // Featured/teaser image (singular, separate)
                imageUrl: '',
                images: Array.isArray(this.images) ? this.images : [],
                timestamp: ((_tx$msg = tx.msg) === null || _tx$msg === void 0 || (_tx$msg = _tx$msg.data) === null || _tx$msg === void 0 ? void 0 : _tx$msg.timestamp) || Date.now(),
                subscriptionTier: 'free',
                excerpt: ''
              };
              tx.msg = {
                module: 'Stack',
                request: 'create stack post request',
                data: _data
              };

              // ========================================================================
              // DIAGNOSTIC: Log field4 value being saved
              // ========================================================================
              _field4Value = 'stack:draft';
              console.log('[DIAG] saveDraftTransaction() Updating draft with field4 =', _field4Value);

              // ========================================================================
              // DIAGNOSTIC: Log exact values being updated (field1, field2, field4, peer)
              // ========================================================================
              console.log('[DIAG] saveDraftTransaction() About to update with:');
              console.log('[DIAG]   - field1: (should remain from original transaction, expected: "Stack")');
              console.log('[DIAG]   - field2: (should remain from original transaction, expected: publicKey)');
              console.log('[DIAG]   - field4:', _field4Value);
              console.log('[DIAG]   - peer: "localhost"');
              console.log('[DIAG]   - tx.signature =', tx.signature || 'N/A');
              console.log('[DIAG]   - tx.msg.module =', (_tx$msg2 = tx.msg) === null || _tx$msg2 === void 0 ? void 0 : _tx$msg2.module);

              // Update existing draft transaction (field1 is auto-populated from tx.msg.module)
              _context7.n = 9;
              return this.app.storage.updateTransaction(tx, {
                field4: _field4Value
              }, 'localhost');
            case 9:
              // ========================================================================
              // DIAGNOSTIC: Confirmation that storage.updateTransaction() resolved
              // ========================================================================
              console.log('[DIAG] saveDraftTransaction() storage.updateTransaction() RESOLVED (draft updated)');

              // ========================================================================
              // DIAGNOSTIC: Immediately verify what was stored by querying back
              // ========================================================================
              if (tx.signature) {
                console.log('[DIAG] saveDraftTransaction() Verifying updated draft by querying storage...');
                this.app.storage.loadTransactions({
                  field1: 'Stack',
                  field4: 'stack:draft',
                  signature: tx.signature
                }, function (verificationTxs) {
                  var verifyCount = verificationTxs ? verificationTxs.length : 0;
                  console.log('[DIAG] saveDraftTransaction() Verification query found', verifyCount, 'matching transactions');
                  if (verifyCount > 0 && verificationTxs[0]) {
                    var verifyTx = verificationTxs[0];
                    console.log('[DIAG] saveDraftTransaction() Verified transaction has:');
                    console.log('[DIAG]   - field1:', verifyTx.field1 || 'N/A');
                    console.log('[DIAG]   - field2:', verifyTx.field2 || 'N/A');
                    console.log('[DIAG]   - field4:', verifyTx.field4 || 'N/A');
                    console.log('[DIAG]   - signature:', verifyTx.signature || 'N/A');
                  } else {
                    console.log('[DIAG] saveDraftTransaction() WARNING: Verification query found NO matching transactions!');
                  }
                }, 'localhost');
              }

              // Log successful update (downgraded from diagnostic)
              console.debug('Stack: storage.updateTransaction() resolved (draft updated)');
            case 10:
              // ========================================================================
              // DIAGNOSTIC: Check whether refreshDrafts() is called afterward
              // ========================================================================
              console.log('[DIAG] saveDraftTransaction() EXIT: refreshDrafts() is NOT called (draft discovery happens on next editor entry)');
              _context7.n = 12;
              break;
            case 11:
              _context7.p = 11;
              _t4 = _context7.v;
              console.error('[DIAG] saveDraftTransaction() ERROR:', _t4);
              console.error('Stack: Error saving draft transaction:', _t4);
              // Re-throw to allow caller to handle error (triggerSave catches it)
              throw _t4;
            case 12:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 11]]);
      }));
      function saveDraftTransaction() {
        return _saveDraftTransaction.apply(this, arguments);
      }
      return saveDraftTransaction;
    }()
    /**
     * Update save state indicator
     */
  }, {
    key: "updateSaveState",
    value: function updateSaveState(state) {
      this.saveState = state;
      this.updateStatusDisplay();
    }

    /**
     * Update status display in sidebar
     * Quiet document state: Saving… → Saved → Draft / Published
     */
  }, {
    key: "updateStatusDisplay",
    value: function updateStatusDisplay() {
      var statusValueElement = document.querySelector('#stack-editor-status-value');
      if (!statusValueElement) return;
      var statusText;
      statusValueElement.classList.remove('saving', 'saved');
      if (this.saveState === 'saving') {
        statusText = 'Saving…';
        statusValueElement.classList.add('saving');
      } else if (this.saveState === 'saved') {
        statusText = 'Saved';
        statusValueElement.classList.add('saved');
      } else {
        statusText = this.isPublished ? 'Published' : 'Draft';
      }
      statusValueElement.textContent = statusText;
    }

    /**
     * Check if document has content and update next step button
     */
  }, {
    key: "updateNextStepButton",
    value: function updateNextStepButton() {
      var nextStepBtn = document.querySelector('#stack-next-step-btn');
      if (!nextStepBtn) return;
      var title = this.getDocumentTitle();
      var editor = document.querySelector('#stack-post-body-editor');
      var hasContent = false;
      if (editor) {
        var blockElements = editor.querySelectorAll('[data-block-id]');
        var _iterator5 = _createForOfIteratorHelper(blockElements),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var blockEl = _step5.value;
            var blockType = blockEl.getAttribute('data-block-type');
            if (blockType === 'paragraph' || blockType === 'heading' || blockType === 'list-item' || blockType === 'blockquote') {
              var text = (blockEl.textContent || '').replace(/\u200B/g, '').trim();
              if (text.length > 0) {
                hasContent = true;
                break;
              }
            } else if (blockType === 'image') {
              hasContent = true;
              break;
            } else if (blockType === 'rawhtml') {
              var html = (blockEl.innerHTML || '').trim();
              if (html.length > 0) {
                hasContent = true;
                break;
              }
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
      var hasTitle = title.trim().length > 0;
      if (hasContent || hasTitle) {
        nextStepBtn.disabled = false;
      } else {
        nextStepBtn.disabled = true;
      }
    }

    /**
     * Get the currently focused block element
     * B1: Block identity is a type system - ONLY editable leaf nodes may have data-block-id
     * Returns only elements with data-block-id (blocks), never structural containers like <ul>
     */
  }, {
    key: "getFocusedBlock",
    value: function getFocusedBlock() {
      var selection = window.getSelection();
      if (!selection.rangeCount) return null;
      var node = selection.anchorNode;
      while (node && node !== document) {
        if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute('data-block-id')) {
          // Code blocks require special handling: <pre> elements with data-block-id must be
          // treated as blocks even when selection is inside nested <code> or other elements
          // The browser may create nested structure (e.g., <pre><code>text</code></pre>),
          // but we must always resolve to the <pre> element that has data-block-id
          if (node.tagName === 'PRE' && node.getAttribute('data-block-type') === 'code') {
            return node;
          }
          return node;
        }
        node = node.parentNode;
      }
      return null;
    }

    /**
     * Ensure the caret is inside a block. If not, create an empty paragraph and move the caret into it.
     * Used by Enter and paste to restore the invariant (caret must live inside a block).
     * @returns {HTMLElement|null} The focused block, or the new block after recovery, or null if no editor.
     */
  }, {
    key: "_ensureFocusedBlock",
    value: function _ensureFocusedBlock() {
      var block = this.getFocusedBlock();
      if (block) return block;
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return null;
      var newBlockElement = document.createElement('p');
      var newBlockId = generateBlockId(this.getBlockCount());
      newBlockElement.setAttribute('data-block-id', newBlockId);
      newBlockElement.setAttribute('data-block-type', 'paragraph');
      newBlockElement.contentEditable = 'true';
      var caretAnchor = document.createTextNode("\u200B");
      newBlockElement.appendChild(caretAnchor);
      editor.appendChild(newBlockElement);
      this.updatePlaceholderVisibility();
      var newRange = document.createRange();
      var newSelection = window.getSelection();
      newRange.setStart(caretAnchor, 0);
      newRange.setEnd(caretAnchor, 0);
      newSelection.removeAllRanges();
      newSelection.addRange(newRange);
      newBlockElement.focus();
      this.autoScrollToCaret();
      return newBlockElement;
    }

    /**
     * Get block count from DOM (replaces this.document.blocks.length)
     * B1: Block identity - counts ONLY elements with data-block-id (true blocks)
     * Structural containers like <ul> are never counted
     */
  }, {
    key: "getBlockCount",
    value: function getBlockCount() {
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return 0;
      return editor.querySelectorAll('[data-block-id]').length;
    }

    /**
     * A2: data-block-index removed - order is derived from DOM position only
     * B4: Adjacency logic must be DOM-safe - never rely on cached indices
     */

    /**
     * Get text offset from selection within a block
     */
    /**
     * Get text offset from selection within a block.
     *
     * STRUCTURAL CONSTRAINT: This function is ONLY for paragraph splitting.
     * Using it elsewhere (normalization, heading/list/blockquote Enter) is a structural violation.
     *
     * Cursor offset logic exists ONLY in paragraph Enter completion.
     * All other Enter paths (heading, list, blockquote) must NOT use cursor offsets.
     */
  }, {
    key: "getTextOffsetInBlock",
    value: function getTextOffsetInBlock(blockElement, selection) {
      var range = selection.getRangeAt(0);
      return this.getTextOffsetFromRange(blockElement, range);
    }

    /**
     * Get block content as serialized text (code as backticks) and cursor offset in that text.
     * Code nodes are serialized as `...` so linkification treats their content as opaque.
     */
  }, {
    key: "getBlockContentForLinkification",
    value: function getBlockContentForLinkification(blockElement, selection) {
      var range = selection && selection.rangeCount ? selection.getRangeAt(0) : null;
      var serialized = '';
      var splitOffset = 0;
      var targetNode = range ? range.startContainer : null;
      var targetOffset = range ? range.startOffset : 0;
      var offsetInNode = function offsetInNode(node) {
        if (node === targetNode) return targetOffset;
        if (node.nodeType === Node.TEXT_NODE) return -1;
        var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
        var pos = 0;
        var n = walker.nextNode();
        while (n) {
          if (n === targetNode) return pos + targetOffset;
          pos += (n.textContent || '').replace(/\u200B/g, '').length;
          n = walker.nextNode();
        }
        return -1;
      };
      var _walk = function walk(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          var text = (node.textContent || '').replace(/\u200B/g, '');
          if (node === targetNode) {
            splitOffset = serialized.length + Math.min(targetOffset, text.length);
          }
          serialized += text;
          return;
        }
        if (node.nodeType === Node.ELEMENT_NODE) {
          var tag = node.tagName ? node.tagName.toLowerCase() : '';
          if (tag === 'code') {
            var inner = (node.textContent || '').replace(/\u200B/g, '');
            var idx = offsetInNode(node);
            if (idx >= 0) {
              splitOffset = serialized.length + 1 + Math.min(idx, inner.length);
            }
            serialized += '`' + inner + '`';
            return;
          }
          if (tag === 'pre') {
            var _inner = (node.textContent || '').replace(/\u200B/g, '');
            var _idx = offsetInNode(node);
            if (_idx >= 0) {
              splitOffset = serialized.length + Math.min(_idx, _inner.length);
            }
            serialized += _inner;
            return;
          }
          for (var i = 0; i < node.childNodes.length; i++) {
            _walk(node.childNodes[i]);
          }
        }
      };
      for (var i = 0; i < blockElement.childNodes.length; i++) {
        _walk(blockElement.childNodes[i]);
      }
      return {
        text: serialized,
        splitOffset: splitOffset
      };
    }

    /**
     * Get text offset from a range within a block
     */
  }, {
    key: "getTextOffsetFromRange",
    value: function getTextOffsetFromRange(blockElement, range) {
      var offset = 0;

      // Walk through text nodes in the block
      var walker = document.createTreeWalker(blockElement, NodeFilter.SHOW_TEXT, null);
      var textNode = walker.nextNode();
      while (textNode) {
        if (textNode === range.startContainer) {
          offset += range.startOffset;
          break;
        }
        // Remove zero-width space from length calculation
        var textLength = textNode.textContent.replace(/\u200B/g, '').length;
        offset += textLength;
        textNode = walker.nextNode();
      }
      return offset;
    }

    /**
     * Move every node after a collapsed caret out of a block.
     * <br> and other elements move intact. The paragraph is not flattened to text,
     * because textContent drops soft breaks and joins the lines.
     */
  }, {
    key: "_extractContentAfterCaret",
    value: function _extractContentAfterCaret(block, range) {
      var fragment = document.createDocumentFragment();
      if (!block) {
        return fragment;
      }

      // An unresolved caret matches the previous string split, which used offset 0.
      if (!range || range.startContainer !== block && !block.contains(range.startContainer)) {
        while (block.firstChild) {
          fragment.appendChild(block.firstChild);
        }
        return fragment;
      }
      var container = range.startContainer;
      var offset = range.startOffset;
      if (container.nodeType === Node.TEXT_NODE) {
        var parent = container.parentNode;
        var index = Array.prototype.indexOf.call(parent.childNodes, container);
        if (offset <= 0) {
          container = parent;
          offset = index;
        } else if (offset >= container.length) {
          container = parent;
          offset = index + 1;
        } else {
          var afterNode = container.splitText(offset);
          container = afterNode.parentNode;
          offset = Array.prototype.indexOf.call(container.childNodes, afterNode);
        }
      }
      while (container && container !== block) {
        var _parent = container.parentNode;
        if (!_parent) {
          break;
        }
        var _index = Array.prototype.indexOf.call(_parent.childNodes, container);
        var afterClone = container.cloneNode(false);
        while (container.childNodes.length > offset) {
          afterClone.appendChild(container.childNodes[offset]);
        }
        if (!afterClone.childNodes.length) {
          container = _parent;
          offset = _index + 1;
          continue;
        }
        if (container.nextSibling) {
          _parent.insertBefore(afterClone, container.nextSibling);
        } else {
          _parent.appendChild(afterClone);
        }
        container = _parent;
        offset = _index + 1;
      }
      if (container === block) {
        while (block.childNodes.length > offset) {
          fragment.appendChild(block.childNodes[offset]);
        }
      }
      return fragment;
    }

    /**
     * Drop inline elements left empty by a split. <br> is a real soft break and stays.
     */
  }, {
    key: "_pruneEmptyInlines",
    value: function _pruneEmptyInlines(block) {
      if (!block) return;
      var elements = Array.from(block.querySelectorAll('*'));
      for (var i = elements.length - 1; i >= 0; i--) {
        var el = elements[i];
        if (!el.parentNode || el.tagName === 'BR') continue;
        if (!el.childNodes.length) {
          el.remove();
        }
      }
    }

    /**
     * Rewrite bare URLs inside each text node. Code stays opaque.
     * Working per text node leaves sibling <br> elements in place.
     */
  }, {
    key: "_linkifyTextNodes",
    value: function _linkifyTextNodes(block) {
      if (!block) return;
      var textNodes = [];
      var walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, {
        acceptNode: function acceptNode(node) {
          var parent = node.parentNode;
          while (parent && parent !== block) {
            var tag = parent.tagName;
            if (tag === 'CODE' || tag === 'PRE') {
              return NodeFilter.FILTER_REJECT;
            }
            parent = parent.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var node = walker.nextNode();
      while (node) {
        textNodes.push(node);
        node = walker.nextNode();
      }
      for (var _i = 0, _textNodes = textNodes; _i < _textNodes.length; _i++) {
        var textNode = _textNodes[_i];
        var original = textNode.textContent;
        var transformed = this._convertBareUrlsToMarkdownLinks(original);
        if (transformed !== original) {
          textNode.textContent = transformed;
        }
      }
    }

    /**
     * Append source's children onto target. Returns the first moved node so the
     * caret can stay at the join without concatenating textContent.
     */
  }, {
    key: "_moveChildNodes",
    value: function _moveChildNodes(target, source) {
      var firstMoved = source.firstChild;
      while (source.firstChild) {
        target.appendChild(source.firstChild);
      }
      return firstMoved;
    }

    /**
     * Convert bare http/https URLs to Markdown link syntax [url](url).
     * Pure text rewrite only. Does not create DOM nodes.
     * Skips URLs already inside [text](url). Strips trailing punctuation in post-processing.
     *
     * Emphasis-aware: emphasis ALWAYS dominates. Links inside emphasized spans are
     * linkified within the span; markers are never included in URLs or hrefs.
     * Supports mixed text + link (e.g. **Check this: https://x.com**) and nested emphasis.
     *
     * Code-invariant: text inside `...` or ```...``` is never linkified.
     */
  }, {
    key: "_convertBareUrlsToMarkdownLinks",
    value: function _convertBareUrlsToMarkdownLinks(text) {
      var _this1 = this;
      if (!text || typeof text !== 'string') return text;

      // Pre-pass: extract code spans (opaque - no linkification). Match ``` before `.
      var codeSpans = [];
      var CODE_PLACEHOLDER = "\0CODE\0";
      text = text.replace(/```[\s\S]*?```/g, function (m) {
        codeSpans.push(m);
        return CODE_PLACEHOLDER + (codeSpans.length - 1) + CODE_PLACEHOLDER;
      });
      text = text.replace(/`[^`]*`/g, function (m) {
        codeSpans.push(m);
        return CODE_PLACEHOLDER + (codeSpans.length - 1) + CODE_PLACEHOLDER;
      });

      // Pre-pass: emphasis spans. Match longest delimiters first (*** before ** before *).
      // For each span, linkify inner content only; never consume emphasis delimiters.
      var emphasisPatterns = [{
        marker: '***',
        re: /\*\*\*([^*]+?)\*\*\*/g
      }, {
        marker: '**',
        re: /\*\*([^*]+?)\*\*/g
      }, {
        marker: '__',
        re: /__([^_]+?)__/g
      }, {
        marker: '*',
        re: /\*([^*]+?)\*/g
      }, {
        marker: '_',
        re: /_([^_]+?)_/g
      }];
      var _loop3 = function _loop3() {
        var _emphasisPatterns$_i = _emphasisPatterns[_i2],
          marker = _emphasisPatterns$_i.marker,
          re = _emphasisPatterns$_i.re;
        text = text.replace(re, function (_, inner) {
          var linkified = _this1._linkifyBareUrlsOnly(inner);
          return "".concat(marker).concat(linkified).concat(marker);
        });
      };
      for (var _i2 = 0, _emphasisPatterns = emphasisPatterns; _i2 < _emphasisPatterns.length; _i2++) {
        _loop3();
      }

      // Standard linkification for non-emphasized bare URLs
      var bareUrlRe = /\b(https?:\/\/[^\s<>\[\]]+)/g;
      text = text.replace(bareUrlRe, function (match, _p1, offset, fullString) {
        // Skip if already inside markdown link: ](href) or [link text
        if (offset >= 2 && fullString.slice(offset - 2, offset) === '](') return match;
        if (offset >= 1 && fullString[offset - 1] === '[') return match;
        var url = match.replace(/[.,;:!?\]]+$/, '');
        var openParens = (url.match(/\(/g) || []).length;
        var closeParens = (url.match(/\)/g) || []).length;
        if (closeParens > openParens && url.endsWith(')')) {
          url = url.slice(0, -1);
        }
        var trailing = match.slice(url.length);
        return "[".concat(url, "](").concat(url, ")").concat(trailing);
      });

      // Restore code spans (unchanged)
      for (var i = 0; i < codeSpans.length; i++) {
        text = text.replace(CODE_PLACEHOLDER + i + CODE_PLACEHOLDER, codeSpans[i]);
      }
      return text;
    }

    /**
     * Linkify bare URLs only (no emphasis handling). Used when processing inner content
     * of emphasis spans. Preserves code spans as opaque.
     */
  }, {
    key: "_linkifyBareUrlsOnly",
    value: function _linkifyBareUrlsOnly(text) {
      if (!text || typeof text !== 'string') return text;
      var codeSpans = [];
      var CODE_PLACEHOLDER = "\0CODE\0";
      text = text.replace(/```[\s\S]*?```/g, function (m) {
        codeSpans.push(m);
        return CODE_PLACEHOLDER + (codeSpans.length - 1) + CODE_PLACEHOLDER;
      });
      text = text.replace(/`[^`]*`/g, function (m) {
        codeSpans.push(m);
        return CODE_PLACEHOLDER + (codeSpans.length - 1) + CODE_PLACEHOLDER;
      });
      var bareUrlRe = /\b(https?:\/\/[^\s<>\[\]]+)/g;
      text = text.replace(bareUrlRe, function (match, _p1, offset, fullString) {
        if (offset >= 2 && fullString.slice(offset - 2, offset) === '](') return match;
        if (offset >= 1 && fullString[offset - 1] === '[') return match;
        var url = match.replace(/[.,;:!?\]]+$/, '');
        var openParens = (url.match(/\(/g) || []).length;
        var closeParens = (url.match(/\)/g) || []).length;
        if (closeParens > openParens && url.endsWith(')')) {
          url = url.slice(0, -1);
        }
        var trailing = match.slice(url.length);
        return "[".concat(url, "](").concat(url, ")").concat(trailing);
      });
      for (var i = 0; i < codeSpans.length; i++) {
        text = text.replace(CODE_PLACEHOLDER + i + CODE_PLACEHOLDER, codeSpans[i]);
      }
      return text;
    }

    /**
     * Clean a bare URL for linkification: strip trailing punctuation.
     * Returns empty string if input is invalid.
     */
  }, {
    key: "_linkifyBareUrl",
    value: function _linkifyBareUrl(url) {
      if (!url || typeof url !== 'string') return '';
      var clean = url.replace(/[.,;:!?\]]+$/, '');
      var openParens = (clean.match(/\(/g) || []).length;
      var closeParens = (clean.match(/\)/g) || []).length;
      if (closeParens > openParens && clean.endsWith(')')) {
        clean = clean.slice(0, -1);
      }
      return clean;
    }

    /**
     * Remove a highlighted range inside the body editor and leave a collapsed caret
     * where the highlight was. Enter prevents the browser default, so this is the
     * only way a selection is removed before the block is split.
     */
  }, {
    key: "deleteExpandedSelection",
    value: function deleteExpandedSelection() {
      var editor = document.querySelector('#stack-post-body-editor');
      var selection = window.getSelection();
      if (!editor || !selection || !selection.rangeCount) {
        return;
      }
      var range = selection.getRangeAt(0);
      if (range.collapsed) {
        return;
      }
      if (!editor.contains(range.startContainer) || !editor.contains(range.endContainer)) {
        return;
      }
      range.deleteContents();
      range.collapse(true);
      selection.removeAllRanges();
      selection.addRange(range);
    }

    /**
     * Handle Enter key - split paragraph block
     * If text is selected, delete selection and insert newline
     * If in a block-formatted line and line is empty, exit the block
     *
     * DOM-AUTHORITATIVE INVARIANT:
     * - This function operates ONLY on DOM elements (focusedBlock, DOM nodes)
     * - NO document/block object model exists or should be referenced
     * - The ONLY allowed state variables are:
     *   * focusedBlock (DOM Element node)
     *   * blockType (string from DOM attribute or tagName)
     *   * selection / range (Selection API objects)
     * - Variables like `block`, `block.text`, `block.type` must NEVER be introduced
     * - All block information must come from DOM inspection (attributes, textContent, tagName)
     */
  }, {
    key: "handleEnterKey",
    value: function handleEnterKey(e) {
      // ========================================================================
      // EDITOR CORE INFRASTRUCTURE
      // ========================================================================
      // This function is editor core infrastructure.
      // Changes must preserve all stated invariants.
      // Do not add recovery logic, heuristics, or alternative code paths.
      //
      // This function implements a deterministic Enter key handling system with
      // strict phase separation: Intent Capture → Normalization → Enter Completion.
      // All invariants, illegal states, and structural rules documented within
      // this function must be preserved. Violations are bugs, not edge cases.
      // ========================================================================

      // ========================================================================
      // ATOMIC EVENT CLAIMING
      // ========================================================================
      // Enter is claimed atomically at the top of the handler to prevent race conditions.
      // Once handleEnterKey() runs, the browser must NEVER process the Enter key.
      // Normalization and completion run under full event control, ensuring deterministic behavior.
      //
      // INVARIANT: Enter prevention is centralized here and must not be reintroduced conditionally.
      // No branch in this function "decides" whether Enter is prevented - it is always prevented.
      e.preventDefault();

      // The browser will not delete a highlight after preventDefault. Remove it
      // first so every Enter path below sees a collapsed caret at that point.
      this.deleteExpandedSelection();

      // DOM repair: blockquote must never be a child of <ul> (ensures clean block boundaries before Enter)
      this._ensureBlockquoteNotInList();

      // ========================================================================
      // PHASE 1: INTENT CAPTURE
      // ========================================================================
      // Capture current editor state and user intent before any mutations.
      // This phase is read-only and establishes the context for all subsequent phases.

      // DOM-AUTHORITATIVE: Get focused block element (DOM node only)
      var focusedBlock = this.getFocusedBlock();
      if (!focusedBlock) {
        // Recovery: caret can end up in the contenteditable root when the last block becomes empty.
        if (!this._ensureFocusedBlock()) {
          throw new Error('Enter pressed in invalid editor state: no focused block (cursor outside block element)');
        }
        return;
      }

      // Postcondition enforcement: track structural mutations
      var didMutateStructure = false;

      // Option 2: Store trailing text from code block normalization for completion phase
      var codeBlockTrailingText = null;

      // ========================================================================
      // BLOCK TYPE INFERENCE RULES (NON-NEGOTIABLE)
      // ========================================================================
      // Block type is defined EXCLUSIVELY by the 'data-block-type' DOM attribute.
      // Valid values: 'paragraph', 'heading', 'list-item', 'blockquote', 'image', 'rawhtml'
      //
      // INVARIANT: Block type must NEVER be inferred from:
      //   - Cursor position or offsets
      //   - Text content patterns (markdown markers, etc.)
      //   - Heuristic analysis
      //   - Tag names alone (e.g., <h1>, <li>, <p>)
      //   - CSS classes or other attributes
      //
      // The 'data-block-type' attribute is the SINGLE SOURCE OF TRUTH for block type.
      // All Enter behavior reasoning must reference this attribute only.
      // DOM-AUTHORITATIVE: Get block type from DOM attribute (string only)
      var blockType = focusedBlock.getAttribute('data-block-type');

      // INVARIANT: blockType must be non-null during Enter handling.
      // If data-block-type is missing, infer ONCE from tagName and set the attribute.
      // This is a one-time fix for blocks that lack the attribute; after this, blockType is authoritative.
      if (blockType === null) {
        var tagName = focusedBlock.tagName.toLowerCase();
        if (tagName === 'p') {
          blockType = 'paragraph';
        } else if (tagName.match(/^h[1-6]$/)) {
          blockType = 'heading';
        } else if (tagName === 'li') {
          blockType = 'list-item';
        } else if (tagName === 'blockquote') {
          blockType = 'blockquote';
        } else if (tagName === 'figure' || tagName === 'img') {
          blockType = 'image';
        } else {
          blockType = 'paragraph'; // Default fallback
        }
        focusedBlock.setAttribute('data-block-type', blockType);
      }

      // CRITICAL INVARIANT: Cursor offset is captured ONCE before any DOM mutations.
      // This offset is VALID ONLY for paragraph-to-paragraph splitting (no normalization).
      // If blockType changes during normalization, this offset becomes INVALID and must be discarded.
      // Normalization ignores cursor position and uses the entire line.
      var selection = window.getSelection();
      if (!selection.rangeCount) {
        throw new Error('Enter pressed in invalid editor state: no selection (selection lost after DOM mutation)');
      }
      var originalCursorOffset = this.getTextOffsetInBlock(focusedBlock, selection);
      var originalBlockText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
      var originalBlockType = blockType; // Track original block type to detect normalization

      // This offset is used ONLY in paragraph-to-paragraph splitting (Enter completion for paragraphs).
      // If blockType changed during normalization, originalCursorOffset is INVALID and must not be used.
      // Normalization does NOT use cursor offsets - it is purely structural.

      // ========================================================================
      // PHASE 2: BLOCK NORMALIZATION
      // ========================================================================
      // B2: Normalization vs Completion separation
      // Normalization: Detects intent only. MUST NOT read Selection/Range, place cursor, or decide grouping.
      // Convert block types (paragraph → heading, paragraph → list) based on
      // markdown markers. This phase normalizes structure but does NOT create
      // sibling blocks. Normalization updates focusedBlock and blockType in place.
      //
      // INVARIANT: Normalization never creates siblings, never returns early.
      // INVARIANT: Enter completion always runs after normalization.
      // INVARIANT: Normalization must not move the cursor. Cursor placement occurs
      //            during Enter completion.
      // INVARIANT: Normalization is purely structural - cursor position is irrelevant.
      //            Normalization removes markdown markers and uses the ENTIRE remaining
      //            line. Cursor offset logic exists ONLY in paragraph splitting.
      //
      // ILLEGAL: Cursor placement in normalization phase
      // - Normalization MUST NEVER place or move the cursor
      // - If cursor is placed here, this is a structural violation
      // - console.warn: "Cursor placement in normalization phase - structural violation"
      //
      // ILLEGAL: Cursor offset usage in normalization phase
      // - Normalization MUST NEVER reference cursor offsets or Selection
      // - If offsets are used here, this is a structural violation
      // - console.warn: "Cursor offset usage in normalization phase - structural violation"

      // Check for markdown heading conversion: "# ", "## ", "### " at start of paragraph
      // Normalization is PURELY STRUCTURAL - no Selection/Range reading allowed
      // PRECONDITION: Block's visible content (after removing ZWSP) must START WITH the trigger
      if (blockType === 'paragraph') {
        var _blockText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
        var trimmedText = _blockText.trimStart();
        var headingLevel = null;
        if (trimmedText.startsWith('### ')) {
          headingLevel = 3;
        } else if (trimmedText.startsWith('## ')) {
          headingLevel = 2;
        } else if (trimmedText.startsWith('# ')) {
          headingLevel = 1;
        }
        if (headingLevel) {
          var leadingWhitespace = _blockText.length - trimmedText.length;
          var markerEndOffset = leadingWhitespace + headingLevel + 1;
          var headingText = _blockText.substring(markerEndOffset);
          var newHeading = document.createElement("h".concat(headingLevel));
          Array.from(focusedBlock.attributes).forEach(function (attr) {
            if (attr.name !== 'data-block-type') {
              newHeading.setAttribute(attr.name, attr.value);
            }
          });
          newHeading.setAttribute('data-block-type', 'heading');
          newHeading.contentEditable = 'true';
          newHeading.textContent = headingText;
          focusedBlock.parentNode.replaceChild(newHeading, focusedBlock);
          focusedBlock = newHeading;
          blockType = 'heading';
        }

        // Check for markdown list creation: "* " or "- " at start of paragraph
        // Normalization is PURELY STRUCTURAL - no Selection/Range reading allowed
        // PRECONDITION: Block's visible content (after removing ZWSP) must START WITH the trigger
        // Note: List normalization was previously restricted to trigger-only blocks (like headers were),
        // but now allows text after the trigger to match header normalization behavior.
        var listBlockText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
        var listTrimmedText = listBlockText.trimStart();
        if (listTrimmedText.startsWith('* ') || listTrimmedText.startsWith('- ')) {
          // Invariant 7: Normalization ONLY detects list intent, does NOT create structure.
          // Convert paragraph to <li> only. <ul> creation and grouping happen in Enter completion.
          var listLeadingWhitespace = listBlockText.length - listTrimmedText.length;
          var listMarkerEndOffset = listLeadingWhitespace + 2;
          var itemText = listBlockText.substring(listMarkerEndOffset);

          // A1: Persist marker explicitly - C2: No clever inference
          var marker = listTrimmedText.startsWith('* ') ? '* ' : '- ';

          // Convert paragraph to <li> (this is converting current block, not creating siblings)
          var liElement = document.createElement('li');
          var liId = generateBlockId(this.getBlockCount());
          liElement.setAttribute('data-block-id', liId);
          liElement.setAttribute('data-block-type', 'list-item');
          liElement.setAttribute('data-list-marker', marker);
          liElement.contentEditable = 'true';
          liElement.textContent = itemText;

          // Replace paragraph with <li> (no <ul> wrapper yet)
          focusedBlock.parentNode.replaceChild(liElement, focusedBlock);

          // Update focusedBlock and blockType for Enter completion
          focusedBlock = liElement;
          blockType = 'list-item';
        }

        // Check for markdown blockquote creation: "> " at start of paragraph
        // Normalization is PURELY STRUCTURAL - no Selection/Range reading allowed
        // PRECONDITION: Block's visible content (after removing ZWSP) must START WITH the trigger
        var blockquoteBlockText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
        var blockquoteTrimmedText = blockquoteBlockText.trimStart();
        if (blockquoteTrimmedText.startsWith('> ')) {
          // Normalization ONLY detects blockquote intent, does NOT create siblings
          var blockquoteLeadingWhitespace = blockquoteBlockText.length - blockquoteTrimmedText.length;
          var blockquoteMarkerEndOffset = blockquoteLeadingWhitespace + 2;
          var blockquoteText = blockquoteBlockText.substring(blockquoteMarkerEndOffset);

          // Convert paragraph to blockquote (this is converting current block, not creating siblings)
          var blockquoteElement = document.createElement('blockquote');
          var blockquoteId = generateBlockId(this.getBlockCount());
          blockquoteElement.setAttribute('data-block-id', blockquoteId);
          blockquoteElement.setAttribute('data-block-type', 'blockquote');
          blockquoteElement.contentEditable = 'true';
          blockquoteElement.textContent = blockquoteText;

          // Replace paragraph with blockquote
          focusedBlock.parentNode.replaceChild(blockquoteElement, focusedBlock);

          // Update focusedBlock and blockType for Enter completion
          focusedBlock = blockquoteElement;
          blockType = 'blockquote';
        }

        // Check for markdown code block creation: "```" at line start (Option 2: supports trailing text)
        // Normalization is PURELY STRUCTURAL - no Selection/Range reading allowed
        // PRECONDITION: After trimming leading whitespace, text must begin with exactly "```"
        // The backticks must be the first non-whitespace characters (line start intent)
        // Normalization is intentionally strict to prevent over-triggering in paste/mid-line scenarios
        var codeBlockText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
        var trimmedStart = codeBlockText.trimStart();
        if (trimmedStart.startsWith('```')) {
          // Verify trailing text (if any) is on the same line (no newlines between backticks and text)
          var afterBackticks = trimmedStart.substring(3);
          var hasNewlineInTrailing = afterBackticks.includes('\n');

          // Only normalize if backticks are at line start and trailing text (if any) is on same line
          if (!hasNewlineInTrailing) {
            // Option 2: Capture trailing text after the three backticks for completion phase
            // The opening backticks are removed; trailing text (if any) is stored for insertion
            var trailingText = afterBackticks.trim() || null;
            codeBlockTrailingText = trailingText; // Store null if empty, not empty string

            // Normalization ONLY detects code block intent, does NOT create siblings
            // Convert paragraph to code block (this is converting current block, not creating siblings)
            var codeElement = document.createElement('pre');
            var codeId = generateBlockId(this.getBlockCount());
            codeElement.setAttribute('data-block-id', codeId);
            codeElement.setAttribute('data-block-type', 'code');
            codeElement.contentEditable = 'true';
            codeElement.textContent = ''; // Start with empty code block (canonical structure)

            // Replace paragraph with code block
            focusedBlock.parentNode.replaceChild(codeElement, focusedBlock);

            // Update focusedBlock and blockType for Enter completion
            focusedBlock = codeElement;
            blockType = 'code';
          }
        }
      }

      // List-item blockquote: "> " at start of list item → break out of list, start new blockquote.
      // Blockquote must never be a child of <ul>; insert after the list.
      if (blockType === 'list-item' && focusedBlock.tagName === 'LI') {
        var liText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
        var liTrimmed = liText.trimStart();
        if (liTrimmed.startsWith('> ')) {
          var leadingWs = liText.length - liTrimmed.length;
          var text = liText.substring(leadingWs + 2);
          var _blockquoteElement = document.createElement('blockquote');
          _blockquoteElement.setAttribute('data-block-id', generateBlockId(this.getBlockCount()));
          _blockquoteElement.setAttribute('data-block-type', 'blockquote');
          _blockquoteElement.contentEditable = 'true';
          _blockquoteElement.textContent = text;
          var ulElement = focusedBlock.parentNode;
          var _editor = ulElement.parentNode;
          ulElement.removeChild(focusedBlock);
          if (ulElement.children.length === 0) {
            _editor.replaceChild(_blockquoteElement, ulElement);
          } else {
            if (ulElement.nextSibling) {
              _editor.insertBefore(_blockquoteElement, ulElement.nextSibling);
            } else {
              _editor.appendChild(_blockquoteElement);
            }
          }
          focusedBlock = _blockquoteElement;
          blockType = 'blockquote';
        }
      }

      // ========================================================================
      // PHASE 3: ENTER COMPLETION
      // ========================================================================
      // Create the next block (sibling) based on current block type and state.
      // This phase always runs after normalization (if any occurred).
      //
      // STRUCTURAL SEPARATION:
      // - Paragraph Enter splits text and requires cursor offset logic
      // - Heading/List/Blockquote Enter exits the block and does NOT split text
      //
      // INVARIANT: Every Enter keypress results in exactly one structural change.
      // INVARIANT: Enter completion always creates sibling blocks.
      // INVARIANT: Enter completion is the sole authority for cursor placement.
      // NOTE: Early returns ARE allowed in this phase (after completion is done),
      //       but NOT in normalization phase (which must always proceed to completion).
      //
      // ========================================================================
      // ILLEGAL STATES (STRUCTURAL VIOLATIONS, NOT EDGE CASES)
      // ========================================================================
      // The following states MUST NEVER occur. If they do, they are bugs, not
      // situations to "handle" with recovery logic:
      //
      // 1. Enter completion without creating a new block
      //    - Every Enter completion MUST create exactly one new block
      //    - If no block is created, this is a structural violation
      //    - console.warn: "Enter completion failed to create new block - structural violation"
      //
      // 2. Cursor placement outside Enter completion
      //    - Cursor placement MUST ONLY occur in Enter completion phase
      //    - Normalization, event handlers, or other code MUST NOT place cursor
      //    - If cursor is placed elsewhere, this is a structural violation
      //    - console.warn: "Cursor placed outside Enter completion - structural violation"
      //
      // 3. Blocks without a text node after Enter
      //    - Every block created by Enter completion MUST have a text node
      //    - textContent='' creates a text node, which is sufficient
      //    - If a block lacks a text node, this is a structural violation
      //    - console.warn: "Block created without text node - structural violation"
      //
      // 4. Selection recovery during Enter handling
      //    - Enter handling MUST NOT attempt to "recover" from stale selection
      //    - Selection is captured once in Phase 1, then cursor is placed deterministically
      //    - If selection is recomputed or "recovered", this is a structural violation
      //    - console.warn: "Selection recovery attempted during Enter - structural violation"

      // ========================================================================
      // LIST ITEM ENTER: Exit list (no text splitting)
      // ========================================================================
      // Heading/List/Blockquote Enter exits the block and does NOT split text.
      // List item Enter exits the list and creates a paragraph below.
      // NO cursor offset logic - this is unconditional block exit.
      //
      // ILLEGAL: Offset logic is illegal here. Cursor offset logic exists ONLY in paragraph splitting.
      // Using getTextOffsetInBlock() or originalCursorOffset here is a structural violation.
      //
      // L1: Only <li> elements are blocks. Enter completion for list items.
      // Invariant 8: Enter completion is the ONLY place where <ul> is created and <li> is appended.
      if (blockType === 'list-item' && focusedBlock.tagName === 'LI') {
        // Invariant 8: Ensure <li> is wrapped in <ul> (may not be if just normalized)
        var _ulElement = focusedBlock.parentNode;
        if (_ulElement.tagName !== 'UL') {
          // <li> is not in <ul> yet - create <ul> and wrap it
          // B4: Adjacency logic must be DOM-safe - skip non-element nodes, never scan more than one block
          var _editor2 = _ulElement;
          var prevBlock = focusedBlock.previousSibling;
          while (prevBlock && prevBlock.nodeType === Node.ELEMENT_NODE && !prevBlock.hasAttribute('data-block-id')) {
            prevBlock = prevBlock.previousSibling;
          }
          if (prevBlock && prevBlock.tagName === 'LI' && prevBlock.getAttribute('data-block-type') === 'list-item') {
            // B4: Adjacency-based grouping - immediately previous block is <li>
            _ulElement = prevBlock.parentNode;
            _ulElement.appendChild(focusedBlock);
          } else {
            // B1: Create new <ul> (no data-block-id or data-block-type) - structural container only
            _ulElement = document.createElement('ul');
            _editor2.insertBefore(_ulElement, focusedBlock);
            _ulElement.appendChild(focusedBlock);
          }
        }
        var listItemText = (focusedBlock.textContent || '').replace(/\u200B/g, '').trim();
        var _isEmpty = listItemText.length === 0;
        if (_isEmpty) {
          // L3: Empty list item exits the list - remove empty <li> and create paragraph below
          var _ulElement2 = focusedBlock.parentNode;
          var _editor3 = _ulElement2.parentNode;
          var ulNextSibling = _ulElement2.nextSibling;
          var willRemoveUl = _ulElement2.children.length === 1;

          // Remove the empty <li>
          _ulElement2.removeChild(focusedBlock);

          // If <ul> is now empty, remove it
          if (willRemoveUl) {
            _ulElement2.parentNode.removeChild(_ulElement2);
          }

          // Create new paragraph below
          var _newBlockElement = document.createElement('p');
          var _newBlockId = generateBlockId(this.getBlockCount());
          _newBlockElement.setAttribute('data-block-id', _newBlockId);
          _newBlockElement.setAttribute('data-block-type', 'paragraph');
          _newBlockElement.contentEditable = 'true';
          var caretAnchor = document.createTextNode("\u200B");
          _newBlockElement.appendChild(caretAnchor);

          // Insert after the list (or where list was if removed)
          if (willRemoveUl) {
            // <ul> was removed - insert where it was
            if (ulNextSibling) {
              _editor3.insertBefore(_newBlockElement, ulNextSibling);
            } else {
              _editor3.appendChild(_newBlockElement);
            }
          } else {
            // <ul> still exists - insert after it
            if (_ulElement2.nextSibling) {
              _editor3.insertBefore(_newBlockElement, _ulElement2.nextSibling);
            } else {
              _editor3.appendChild(_newBlockElement);
            }
          }
          this.updatePlaceholderVisibility();
          var _newRange = document.createRange();
          var _newSelection = window.getSelection();
          _newRange.setStart(caretAnchor, 0);
          _newRange.setEnd(caretAnchor, 0);
          _newSelection.removeAllRanges();
          _newSelection.addRange(_newRange);
          _newBlockElement.focus();
          this.autoScrollToCaret();
          didMutateStructure = true;
          return;
        } else {
          // L4: Non-empty list item continues the list - create new <li> with same marker
          var _ulElement3 = focusedBlock.parentNode;
          var _editor4 = _ulElement3.parentNode;

          // A1: Read marker from stored data, NOT from textContent - C2: No clever inference
          var _marker = focusedBlock.getAttribute('data-list-marker') || '- ';

          // Create new <li> element
          var newLiElement = document.createElement('li');
          var newLiId = generateBlockId(this.getBlockCount());
          newLiElement.setAttribute('data-block-id', newLiId);
          newLiElement.setAttribute('data-block-type', 'list-item');
          newLiElement.setAttribute('data-list-marker', _marker);
          newLiElement.contentEditable = 'true';

          // I2: <li>.textContent MUST NEVER include the marker - marker is in data-list-marker only
          // I3: Visual markers rendered via CSS, not textContent
          var _caretAnchor = document.createTextNode("\u200B");
          newLiElement.appendChild(_caretAnchor);

          // Append to existing <ul>
          _ulElement3.appendChild(newLiElement);
          this.updatePlaceholderVisibility();
          var _newRange2 = document.createRange();
          var _newSelection2 = window.getSelection();
          _newRange2.setStart(_caretAnchor, 0);
          _newRange2.setEnd(_caretAnchor, 0);
          _newSelection2.removeAllRanges();
          _newSelection2.addRange(_newRange2);
          newLiElement.focus();
          this.autoScrollToCaret();
          didMutateStructure = true;
          return;
        }
      }

      // ========================================================================
      // EMPTY BLOCKQUOTE EXIT: Remove blockquote and create paragraph in its place
      // ========================================================================
      // Enter on empty blockquote: Remove the blockquote, create paragraph in its place.
      // NO cursor offset logic - this is unconditional block replacement.
      //
      // ILLEGAL: Offset logic is illegal here. Cursor offset logic exists ONLY in paragraph splitting.
      var blockText = (focusedBlock.textContent || '').replace(/\u200B/g, '').trim();
      var isEmpty = blockText.length === 0;
      if (blockType === 'blockquote' && isEmpty) {
        // Remove blockquote and create paragraph in its place
        // e.preventDefault() already called at function start
        // NO cursor offset logic - this is unconditional block replacement
        // ILLEGAL: Offset logic is illegal here

        var _editor5 = focusedBlock.parentNode;
        var _newBlockElement2 = document.createElement('p');
        var _newBlockId2 = generateBlockId(this.getBlockCount());
        _newBlockElement2.setAttribute('data-block-id', _newBlockId2);
        _newBlockElement2.setAttribute('data-block-type', 'paragraph');
        _newBlockElement2.contentEditable = 'true';
        // ILLEGAL: Blocks MUST have a text node. ENTER completion must ensure new blocks contain a caret anchor.
        var _caretAnchor2 = document.createTextNode("\u200B");
        _newBlockElement2.appendChild(_caretAnchor2);

        // Replace blockquote with paragraph
        _editor5.replaceChild(_newBlockElement2, focusedBlock);
        this.updatePlaceholderVisibility();

        // Enter completion is the sole authority for cursor placement.
        var _newRange3 = document.createRange();
        var _newSelection3 = window.getSelection();
        _newRange3.setStart(_caretAnchor2, 0);
        _newRange3.setEnd(_caretAnchor2, 0);
        _newSelection3.removeAllRanges();
        _newSelection3.addRange(_newRange3);
        _newBlockElement2.focus();
        this.autoScrollToCaret();
        didMutateStructure = true;
        return;
      }

      // ========================================================================
      // EMPTY BLOCK EXIT: Exit block when empty (no text splitting)
      // ========================================================================
      // Heading/List Enter exits the block and does NOT split text.
      // When the block is empty, convert it to paragraph and create new paragraph below.
      // NO cursor offset logic - this is unconditional block exit.
      //
      // ILLEGAL: Offset logic is illegal here. Cursor offset logic exists ONLY in paragraph splitting.
      // Using getTextOffsetInBlock() or originalCursorOffset here is a structural violation.
      var isBlockFormatted = blockType === 'list-item' || blockType === 'heading';
      var isEmptyFormatted = blockText.length === 0;
      if (isBlockFormatted && isEmptyFormatted) {
        // EXIT BLOCK: Remove formatting and create normal paragraph
        // e.preventDefault() already called at function start
        // NO cursor offset logic - this is unconditional block exit
        // ILLEGAL: Offset logic is illegal here

        // Convert current block to paragraph IN PLACE
        focusedBlock.setAttribute('data-block-type', 'paragraph');
        focusedBlock.textContent = '';
        var emptyTextNode = document.createTextNode("\u200B");
        focusedBlock.appendChild(emptyTextNode);

        // Create new paragraph block in DOM
        // ILLEGAL: Enter completion MUST create a new block. If no block is created here, this is a bug.
        var _editor6 = focusedBlock.parentNode;
        var _newBlockElement3 = document.createElement('p');
        var _newBlockId3 = generateBlockId(this.getBlockCount());
        _newBlockElement3.setAttribute('data-block-id', _newBlockId3);
        _newBlockElement3.setAttribute('data-block-type', 'paragraph');
        _newBlockElement3.contentEditable = 'true';
        // ILLEGAL: Blocks MUST have a text node. ENTER completion must ensure new blocks contain a caret anchor.
        // Empty block: ensure caret anchor exists for stable cursor placement
        var _caretAnchor3 = document.createTextNode("\u200B");
        _newBlockElement3.appendChild(_caretAnchor3);

        // Insert after current block
        if (focusedBlock.nextSibling) {
          _editor6.insertBefore(_newBlockElement3, focusedBlock.nextSibling);
        } else {
          _editor6.appendChild(_newBlockElement3);
        }

        // Update placeholder visibility
        this.updatePlaceholderVisibility();

        // Enter completion is the sole authority for cursor placement.
        // ILLEGAL: Cursor placement MUST ONLY occur in Enter completion. If placed elsewhere, this is a bug.
        // Cursor placement is deterministic: always at offset 0 of the text node.
        // ENTER completion ensures the editor is in a stable state with exactly one active block
        // and a valid collapsed selection inside that block.
        // ILLEGAL: Selection recovery is forbidden. Selection is captured once, cursor is placed deterministically.
        var _newRange4 = document.createRange();
        var _newSelection4 = window.getSelection();
        _newRange4.setStart(_caretAnchor3, 0);
        _newRange4.setEnd(_caretAnchor3, 0);
        _newSelection4.removeAllRanges();
        _newSelection4.addRange(_newRange4);
        _newBlockElement3.focus();
        this.autoScrollToCaret();
        didMutateStructure = true;
        return;
      }

      // ========================================================================
      // CODE BLOCK ENTER: Insert newline or exit block
      // ========================================================================
      // Enter inside code block either inserts a newline (didMutateStructure = false allowed)
      // or exits the block if user types "```" on an empty line.
      // Code blocks use cursor position to detect exit trigger, but do NOT split text.
      if (blockType === 'code') {
        // Option 2: If code block was just normalized with trailing text, insert it as first line
        if (codeBlockTrailingText !== null) {
          // Insert trailing text as the first line inside the code block
          // Canonical structure: code block content always begins on its own line
          var _textNode = document.createTextNode(codeBlockTrailingText);
          focusedBlock.appendChild(_textNode);

          // Place cursor immediately after the inserted text
          var _newRange5 = document.createRange();
          var _newSelection5 = window.getSelection();
          _newRange5.setStart(_textNode, _textNode.textContent.length);
          _newRange5.setEnd(_textNode, _textNode.textContent.length);
          _newSelection5.removeAllRanges();
          _newSelection5.addRange(_newRange5);
          focusedBlock.focus();
          this.autoScrollToCaret();

          // Clear the trailing text (one-time insertion)
          codeBlockTrailingText = null;
          didMutateStructure = true;
          return;
        }
        // Check if current line is exactly "```" - if so, exit code block
        var codeText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
        var _currentSelection = window.getSelection();
        if (_currentSelection.rangeCount > 0) {
          var range = _currentSelection.getRangeAt(0);
          // Calculate cursor offset directly from range (not using getTextOffsetInBlock helper)
          var cursorOffset = 0;
          var walker = document.createTreeWalker(focusedBlock, NodeFilter.SHOW_TEXT, null);
          var _textNode2 = walker.nextNode();
          while (_textNode2) {
            if (_textNode2 === range.startContainer) {
              cursorOffset += range.startOffset;
              break;
            }
            var textLength = _textNode2.textContent.replace(/\u200B/g, '').length;
            cursorOffset += textLength;
            _textNode2 = walker.nextNode();
          }

          // Find the current line by looking backwards for newline
          var lineStart = 0;
          for (var i = cursorOffset - 1; i >= 0; i--) {
            if (codeText[i] === '\n') {
              lineStart = i + 1;
              break;
            }
          }

          // Find the end of the current line
          var lineEnd = codeText.length;
          for (var _i3 = cursorOffset; _i3 < codeText.length; _i3++) {
            if (codeText[_i3] === '\n') {
              lineEnd = _i3;
              break;
            }
          }

          // Get current line and check if it's exactly "```"
          var currentLine = codeText.substring(lineStart, lineEnd).trim();
          if (currentLine === '```') {
            // Exit code block: create paragraph below
            var _editor7 = focusedBlock.parentNode;
            var _newBlockElement4 = document.createElement('p');
            var _newBlockId4 = generateBlockId(this.getBlockCount());
            _newBlockElement4.setAttribute('data-block-id', _newBlockId4);
            _newBlockElement4.setAttribute('data-block-type', 'paragraph');
            _newBlockElement4.contentEditable = 'true';
            var _caretAnchor4 = document.createTextNode("\u200B");
            _newBlockElement4.appendChild(_caretAnchor4);

            // Insert after code block
            if (focusedBlock.nextSibling) {
              _editor7.insertBefore(_newBlockElement4, focusedBlock.nextSibling);
            } else {
              _editor7.appendChild(_newBlockElement4);
            }
            this.updatePlaceholderVisibility();
            var _newRange6 = document.createRange();
            var _newSelection6 = window.getSelection();
            _newRange6.setStart(_caretAnchor4, 0);
            _newRange6.setEnd(_caretAnchor4, 0);
            _newSelection6.removeAllRanges();
            _newSelection6.addRange(_newRange6);
            _newBlockElement4.focus();
            this.autoScrollToCaret();
            didMutateStructure = true;
            return;
          }
        }

        // Not exiting: manually insert newline into code block
        // didMutateStructure = false is explicitly allowed for code block newlines
        // This is the ONLY case where didMutateStructure = false is allowed
        // Since e.preventDefault() was called, we must manually insert the newline
        if (_currentSelection.rangeCount > 0) {
          var _range = _currentSelection.getRangeAt(0);
          var container = _range.startContainer;
          if (container.nodeType === Node.TEXT_NODE && container.parentNode === focusedBlock) {
            // Cursor is in a text node directly inside PRE: insert newline directly
            var offset = _range.startOffset;
            var _text2 = container.textContent;
            container.textContent = _text2.substring(0, offset) + '\n' + _text2.substring(offset);
            // Place cursor after the newline
            var _newRange7 = document.createRange();
            _newRange7.setStart(container, offset + 1);
            _newRange7.setEnd(container, offset + 1);
            _currentSelection.removeAllRanges();
            _currentSelection.addRange(_newRange7);
          } else {
            // Cursor is in PRE element or not in a direct text node:
            // Calculate text offset and insert newline into text content
            var insertOffset = 0;
            var _walker = document.createTreeWalker(focusedBlock, NodeFilter.SHOW_TEXT, null);
            var node = _walker.nextNode();
            while (node) {
              if (node === _range.startContainer) {
                insertOffset += _range.startOffset;
                break;
              }
              insertOffset += node.textContent.replace(/\u200B/g, '').length;
              node = _walker.nextNode();
            }

            // Get all text content and insert newline
            var _codeText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
            var newText = _codeText.substring(0, insertOffset) + '\n' + _codeText.substring(insertOffset);

            // Replace all child nodes with a single text node containing the updated text
            while (focusedBlock.firstChild) {
              focusedBlock.removeChild(focusedBlock.firstChild);
            }
            var newTextNode = document.createTextNode(newText);
            focusedBlock.appendChild(newTextNode);

            // Place cursor after the inserted newline
            var _newRange8 = document.createRange();
            _newRange8.setStart(newTextNode, insertOffset + 1);
            _newRange8.setEnd(newTextNode, insertOffset + 1);
            _currentSelection.removeAllRanges();
            _currentSelection.addRange(_newRange8);
          }
        }
        // didMutateStructure remains false - this is the whitelisted exception
        return;
      }

      // ========================================================================
      // HEADING/BLOCKQUOTE ENTER: Exit block (no text splitting)
      // ========================================================================
      // Heading/List/Blockquote Enter exits the block and does NOT split text.
      // This path does NOT use cursor offset logic - it unconditionally exits the block
      // and creates a new paragraph below, leaving the current block unchanged.
      // (List items are handled above with special logic for continuing/exiting lists)
      // (Empty blocks are handled above - they exit the block format)
      // Enter completion is the sole authority for cursor placement.
      //
      // ILLEGAL: Offset logic is illegal here. Cursor offset logic exists ONLY in paragraph splitting.
      // Using getTextOffsetInBlock() or originalCursorOffset here is a structural violation.
      if (blockType === 'heading' || blockType === 'blockquote') {
        // Exit heading/blockquote: leave current block unchanged, create new paragraph below
        // e.preventDefault() already called at function start
        // NO cursor offset logic - this is unconditional block exit
        // ILLEGAL: Offset logic is illegal here

        // Create new paragraph block in DOM
        // (List items are handled earlier and never reach this code path)
        // ILLEGAL: Enter completion MUST create a new block. If no block is created here, this is a bug.
        var _editor8 = focusedBlock.parentNode;
        var _newBlockElement5 = document.createElement('p');
        _newBlockElement5.setAttribute('data-block-type', 'paragraph');
        var _newBlockId5 = generateBlockId(this.getBlockCount());
        _newBlockElement5.setAttribute('data-block-id', _newBlockId5);
        _newBlockElement5.contentEditable = 'true';
        // ILLEGAL: Blocks MUST have a text node. ENTER completion must ensure new blocks contain a caret anchor.
        // Empty block: ensure caret anchor exists for stable cursor placement
        var _caretAnchor5 = document.createTextNode("\u200B");
        _newBlockElement5.appendChild(_caretAnchor5);

        // Insert after current block
        if (focusedBlock.nextSibling) {
          _editor8.insertBefore(_newBlockElement5, focusedBlock.nextSibling);
        } else {
          _editor8.appendChild(_newBlockElement5);
        }

        // Update placeholder visibility
        this.updatePlaceholderVisibility();

        // Enter completion is the sole authority for cursor placement.
        // ILLEGAL: Cursor placement MUST ONLY occur in Enter completion. If placed elsewhere, this is a bug.
        // Cursor placement is deterministic: always at offset 0 of the text node.
        // ENTER completion ensures the editor is in a stable state with exactly one active block
        // and a valid collapsed selection inside that block.
        // ILLEGAL: Selection recovery is forbidden. Selection is captured once, cursor is placed deterministically.
        var _newRange9 = document.createRange();
        var _newSelection7 = window.getSelection();
        _newRange9.setStart(_caretAnchor5, 0);
        _newRange9.setEnd(_caretAnchor5, 0);
        _newSelection7.removeAllRanges();
        _newSelection7.addRange(_newRange9);
        _newBlockElement5.focus();
        this.autoScrollToCaret();
        didMutateStructure = true;
        return;
      }

      // For other block types (image, rawhtml), Enter is invalid
      // Note: e.preventDefault() was already called at function start, so default behavior is prevented
      // Silent Enter failures are forbidden - invalid states must throw, not return silently
      if (blockType !== 'paragraph') {
        throw new Error("Enter pressed in invalid editor state: block type '".concat(blockType, "' is not editable"));
      }

      // ========================================================================
      // PARAGRAPH ENTER: Split the block at the caret
      // ========================================================================
      // Paragraph Enter splits the live child nodes at the caret.
      // This is the ONLY Enter path that divides a block's contents.
      // MANDATORY FALLBACK: This is the mandatory fallback for normal paragraph splitting.
      // If this code does not run, Enter is broken.
      // This ensures that EVERY Enter keypress in a paragraph results in exactly one structural action.
      // e.preventDefault() already called at function start

      // Split the live children at the caret. Soft breaks are <br> nodes; assigning
      // textContent drops them and concatenates the lines. Linkification rewrites
      // each text node, so a URL inside <code> stays opaque and sibling <br>s stay.
      var currentSelection = window.getSelection();
      var splitRange = currentSelection.rangeCount ? currentSelection.getRangeAt(0) : null;
      var afterFragment = this._extractContentAfterCaret(focusedBlock, splitRange);
      this._pruneEmptyInlines(focusedBlock);
      focusedBlock.normalize();
      if (!focusedBlock.firstChild) {
        focusedBlock.appendChild(document.createTextNode("\u200B"));
      }
      this._linkifyTextNodes(focusedBlock);

      // Create new paragraph block in DOM
      // ILLEGAL: Enter completion MUST create a new block. If no block is created here, this is a bug.
      var editor = focusedBlock.parentNode;
      var newBlockElement = document.createElement('p');
      var newBlockId = generateBlockId(this.getBlockCount());
      newBlockElement.setAttribute('data-block-id', newBlockId);
      newBlockElement.setAttribute('data-block-type', 'paragraph');
      newBlockElement.contentEditable = 'true';
      newBlockElement.appendChild(afterFragment);
      this._pruneEmptyInlines(newBlockElement);
      newBlockElement.normalize();
      this._linkifyTextNodes(newBlockElement);
      // ILLEGAL: Blocks MUST have a text node. A trailing split can start on a <br>.
      // ENTER completion must ensure new blocks contain a caret anchor for stable cursor placement.
      if (!newBlockElement.firstChild || newBlockElement.firstChild.nodeType !== Node.TEXT_NODE) {
        var _caretAnchor6 = document.createTextNode("\u200B");
        newBlockElement.insertBefore(_caretAnchor6, newBlockElement.firstChild);
      }

      // Insert after current block
      if (focusedBlock.nextSibling) {
        editor.insertBefore(newBlockElement, focusedBlock.nextSibling);
      } else {
        editor.appendChild(newBlockElement);
      }
      didMutateStructure = true;

      // Update placeholder visibility
      this.updatePlaceholderVisibility();

      // Enter completion is the sole authority for cursor placement.
      // ILLEGAL: Cursor placement MUST ONLY occur in Enter completion. If placed elsewhere, this is a bug.
      // Cursor placement is deterministic: always at offset 0 of the text node.
      // ENTER completion ensures the editor is in a stable state with exactly one active block
      // and a valid collapsed selection inside that block.
      // ILLEGAL: Selection recovery is forbidden. Selection is captured once, cursor is placed deterministically.
      var newRange = document.createRange();
      var newSelection = window.getSelection();
      var textNode = newBlockElement.firstChild;
      if (!textNode || textNode.nodeType !== Node.TEXT_NODE) {
        throw new Error('Enter completion created block without text node - structural violation');
      }
      newRange.setStart(textNode, 0);
      newRange.setEnd(textNode, 0);
      newSelection.removeAllRanges();
      newSelection.addRange(newRange);
      newBlockElement.focus();
      this.autoScrollToCaret();

      // Postcondition enforcement: every Enter must result in exactly one structural mutation
      // EXCEPTION: Code blocks allow didMutateStructure = false when Enter inserts a newline
      // This is the ONLY whitelisted exception to the postcondition
      if (!didMutateStructure && blockType !== 'code') {
        throw new Error('Enter key violated postcondition: no structural mutation occurred');
      }
    }

    /**
     * Handle SHIFT+ENTER key - insert soft newline
     * Editor is the SOLE authority over structural mutations, including soft newlines.
     * SHIFT+ENTER inserts a newline that the editor tracks internally.
     */
  }, {
    key: "handleShiftEnterKey",
    value: function handleShiftEnterKey(e) {
      // Prevent browser default behavior - editor controls all newline insertion
      e.preventDefault();
      var focusedBlock = this.getFocusedBlock();
      if (!focusedBlock) {
        return;
      }
      var blockType = focusedBlock.getAttribute('data-block-type');
      var selection = window.getSelection();
      if (!selection.rangeCount) {
        return;
      }
      var range = selection.getRangeAt(0);

      // For code blocks, SHIFT+ENTER behaves the same as ENTER (insert newline)
      if (blockType === 'code') {
        // Use the same logic as ENTER in code blocks - insert newline character
        var container = range.startContainer;
        if (container.nodeType === Node.TEXT_NODE && container.parentNode === focusedBlock) {
          // Cursor is in a text node directly inside PRE: insert newline directly
          var offset = range.startOffset;
          var text = container.textContent;
          container.textContent = text.substring(0, offset) + '\n' + text.substring(offset);
          // Place cursor after the newline
          var newRange = document.createRange();
          newRange.setStart(container, offset + 1);
          newRange.setEnd(container, offset + 1);
          selection.removeAllRanges();
          selection.addRange(newRange);
        } else {
          // Cursor is in PRE element or not in a direct text node:
          // Calculate text offset and insert newline into text content
          var insertOffset = 0;
          var walker = document.createTreeWalker(focusedBlock, NodeFilter.SHOW_TEXT, null);
          var node = walker.nextNode();
          while (node) {
            if (node === range.startContainer) {
              insertOffset += range.startOffset;
              break;
            }
            insertOffset += node.textContent.replace(/\u200B/g, '').length;
            node = walker.nextNode();
          }

          // Get all text content and insert newline
          var codeText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
          var newText = codeText.substring(0, insertOffset) + '\n' + codeText.substring(insertOffset);

          // Replace all child nodes with a single text node containing the updated text
          while (focusedBlock.firstChild) {
            focusedBlock.removeChild(focusedBlock.firstChild);
          }
          var newTextNode = document.createTextNode(newText);
          focusedBlock.appendChild(newTextNode);

          // Place cursor after the inserted newline
          var _newRange0 = document.createRange();
          _newRange0.setStart(newTextNode, insertOffset + 1);
          _newRange0.setEnd(newTextNode, insertOffset + 1);
          selection.removeAllRanges();
          selection.addRange(_newRange0);
        }
        return;
      }

      // For paragraphs and other text blocks, insert <br> element for soft newline
      // This creates a line break within the same block (editor-tracked)
      if (blockType === 'paragraph' || blockType === 'list-item' || blockType === 'blockquote') {
        // Delete any selected content first
        if (!range.collapsed) {
          range.deleteContents();
        }

        // Insert <br> element at cursor position
        var br = document.createElement('br');
        range.insertNode(br);

        // A <br> with nothing after it is not painted, so the first Shift+Enter
        // at the end of typed text looks like a no-op. Anchor it. Serialization
        // strips U+200B, so the saved break stays a single hard line break.
        var caretNode = br.nextSibling;
        var needsAnchor = !caretNode || caretNode.nodeType === Node.TEXT_NODE && caretNode.textContent === '';
        if (needsAnchor) {
          var anchor = document.createTextNode("\u200B");
          if (caretNode && caretNode.nodeType === Node.TEXT_NODE) {
            caretNode.parentNode.replaceChild(anchor, caretNode);
          } else {
            br.parentNode.insertBefore(anchor, caretNode);
          }
          caretNode = anchor;
        }
        if (caretNode && caretNode.nodeType === Node.TEXT_NODE) {
          range.setStart(caretNode, 0);
          range.collapse(true);
        } else {
          range.setStartAfter(br);
          range.collapse(true);
        }
        selection.removeAllRanges();
        selection.addRange(range);

        // Normalize adjacent text nodes if needed
        if (br.nextSibling && br.nextSibling.nodeType === Node.TEXT_NODE && br.previousSibling && br.previousSibling.nodeType === Node.TEXT_NODE) {
          // Both sides are text nodes - this is fine, no normalization needed
        } else if (br.nextSibling && br.nextSibling.nodeType === Node.TEXT_NODE) {
          focusedBlock.normalize();
        }

        // Schedule serialization to update editor state
        this.scheduleSerialization();
        this.updatePlaceholderVisibility();
        return;
      }

      // For other block types (heading, image, rawhtml), SHIFT+ENTER does nothing
      // (or could beep/feedback, but silently ignoring is acceptable)
    }

    /**
     * Handle Backspace key - merge with previous block if at start, or delete image if adjacent
     * DOM is authoritative: sync from DOM FIRST
     */
  }, {
    key: "handleBackspaceKey",
    value: function handleBackspaceKey(e) {
      // DOM repair: blockquote must never be a child of <ul> (ensures clean block boundaries before Backspace)
      this._ensureBlockquoteNotInList();

      // Check if an image is selected first
      var selectedImage = document.querySelector('.create-post .body figure.selected');
      if (selectedImage) {
        e.preventDefault();
        this.deleteSelectedImage(selectedImage);
        return;
      }
      var focusedBlock = this.getFocusedBlock();
      if (!focusedBlock) return;
      var blockType = focusedBlock.getAttribute('data-block-type');
      var selection = window.getSelection();
      if (!selection.rangeCount) return;

      // A highlight is not a caret at the start of the block. Leave it to the
      // browser so Backspace (the Mac Delete key) removes the selected text
      // instead of merging or unformatting the whole block.
      var range = selection.getRangeAt(0);
      if (!range.collapsed) {
        return;
      }

      // Don't allow caret to enter image blocks - move to previous block
      if (blockType === 'image') {
        e.preventDefault();

        // A2: Order derived from DOM position, not cached index
        var editor = focusedBlock.parentNode;
        var allBlocks = Array.from(editor.querySelectorAll('[data-block-id]'));
        var blockIndex = allBlocks.indexOf(focusedBlock);
        // Move caret to previous block if it exists
        if (blockIndex > 0) {
          var prevBlockEl = allBlocks[blockIndex - 1];
          if (prevBlockEl) {
            setTimeout(function () {
              if (prevBlockEl && prevBlockEl.hasAttribute('contenteditable')) {
                var newRange = document.createRange();
                var newSelection = window.getSelection();
                if (prevBlockEl.firstChild && prevBlockEl.firstChild.nodeType === Node.TEXT_NODE) {
                  var textLength = prevBlockEl.firstChild.textContent.length;
                  newRange.setStart(prevBlockEl.firstChild, textLength);
                  newRange.setEnd(prevBlockEl.firstChild, textLength);
                } else {
                  newRange.setStart(prevBlockEl, prevBlockEl.childNodes.length);
                  newRange.setEnd(prevBlockEl, prevBlockEl.childNodes.length);
                }
                newSelection.removeAllRanges();
                newSelection.addRange(newRange);
                prevBlockEl.focus();
              }
            }, 0);
          }
        }
        return;
      }

      // Handle removal of block formatting when cursor is at start of block-formatted line
      var cursorOffset = this.getTextOffsetInBlock(focusedBlock, selection);
      var isAtStart = cursorOffset === 0;
      if (isAtStart && (blockType === 'list-item' || blockType === 'blockquote' || blockType === 'heading')) {
        // REMOVE BLOCK FORMATTING: Convert back to paragraph IN PLACE
        e.preventDefault();
        var blockText = (focusedBlock.textContent || '').replace(/\u200B/g, '');

        // Convert in place
        if (blockType === 'heading') {
          // Replace heading with paragraph
          var newParagraph = document.createElement('p');
          Array.from(focusedBlock.attributes).forEach(function (attr) {
            if (attr.name !== 'data-block-type' && attr.name !== 'class') {
              newParagraph.setAttribute(attr.name, attr.value);
            }
          });
          newParagraph.setAttribute('data-block-type', 'paragraph');
          newParagraph.contentEditable = 'true';
          newParagraph.textContent = blockText || "\u200B";
          focusedBlock.parentNode.replaceChild(newParagraph, focusedBlock);

          // Restore cursor synchronously
          var newRange = document.createRange();
          var newSelection = window.getSelection();
          var textNode = newParagraph.firstChild;
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            newRange.setStart(textNode, 0);
            newRange.setEnd(textNode, 0);
          } else {
            newRange.setStart(newParagraph, 0);
            newRange.setEnd(newParagraph, 0);
          }
          newSelection.removeAllRanges();
          newSelection.addRange(newRange);
          newParagraph.focus();
        } else {
          // Convert list-item/blockquote in place
          focusedBlock.setAttribute('data-block-type', 'paragraph');
          if (blockText.length === 0) {
            focusedBlock.textContent = '';
            focusedBlock.appendChild(document.createTextNode("\u200B"));
          }

          // Restore cursor synchronously
          var _newRange1 = document.createRange();
          var _newSelection8 = window.getSelection();
          var _textNode3 = focusedBlock.firstChild;
          if (_textNode3 && _textNode3.nodeType === Node.TEXT_NODE) {
            _newRange1.setStart(_textNode3, 0);
            _newRange1.setEnd(_textNode3, 0);
          } else {
            _newRange1.setStart(focusedBlock, 0);
            _newRange1.setEnd(focusedBlock, 0);
          }
          _newSelection8.removeAllRanges();
          _newSelection8.addRange(_newRange1);
          focusedBlock.focus();
        }
        this.updatePlaceholderVisibility();
        return;
      }

      // Handle deletion when caret is at start of paragraph
      // A2: Order derived from DOM position, not cached index
      if (blockType === 'paragraph' && isAtStart) {
        var _editor9 = focusedBlock.parentNode;
        var _allBlocks = Array.from(_editor9.querySelectorAll('[data-block-id]'));
        var _blockIndex = _allBlocks.indexOf(focusedBlock);
        if (_blockIndex > 0) {
          var _prevBlockEl = _allBlocks[_blockIndex - 1];

          // If previous block is an image, delete it from DOM
          if (_prevBlockEl && _prevBlockEl.getAttribute('data-block-type') === 'image') {
            e.preventDefault();
            if (_prevBlockEl) {
              _prevBlockEl.remove();
              this.updatePlaceholderVisibility();

              // Focus current block synchronously
              var _newRange10 = document.createRange();
              var _newSelection9 = window.getSelection();
              var _textNode4 = focusedBlock.firstChild;
              if (_textNode4 && _textNode4.nodeType === Node.TEXT_NODE) {
                _newRange10.setStart(_textNode4, 0);
                _newRange10.setEnd(_textNode4, 0);
              } else {
                _newRange10.setStart(focusedBlock, 0);
                _newRange10.setEnd(focusedBlock, 0);
              }
              _newSelection9.removeAllRanges();
              _newSelection9.addRange(_newRange10);
              focusedBlock.focus();
            }
            return;
          }

          // A3: DOM-authoritative - check previous block from DOM, not legacy model
          if (_prevBlockEl && _prevBlockEl.getAttribute('data-block-type') === 'paragraph') {
            e.preventDefault();

            // Move nodes so <br> soft breaks survive the merge.
            var firstMoved = this._moveChildNodes(_prevBlockEl, focusedBlock);
            focusedBlock.remove();

            // Restore cursor synchronously at the join, then normalize so the
            // browser keeps that caret when adjacent text nodes merge.
            this.updatePlaceholderVisibility();
            var _newRange11 = document.createRange();
            var _newSelection0 = window.getSelection();
            if (firstMoved && firstMoved.parentNode === _prevBlockEl) {
              if (firstMoved.nodeType === Node.TEXT_NODE) {
                _newRange11.setStart(firstMoved, 0);
              } else {
                _newRange11.setStartBefore(firstMoved);
              }
            } else if (_prevBlockEl.lastChild && _prevBlockEl.lastChild.nodeType === Node.TEXT_NODE) {
              var end = _prevBlockEl.lastChild.textContent.length;
              _newRange11.setStart(_prevBlockEl.lastChild, end);
            } else {
              var caretAnchor = document.createTextNode("\u200B");
              _prevBlockEl.appendChild(caretAnchor);
              _newRange11.setStart(caretAnchor, 0);
            }
            _newRange11.collapse(true);
            _newSelection0.removeAllRanges();
            _newSelection0.addRange(_newRange11);
            _prevBlockEl.normalize();
            _prevBlockEl.focus();
            return;
          }
        }
      }

      // Allow default backspace behavior for other cases
    }

    /**
     * Handle Delete key - merge with next block if at end, or delete image if adjacent
     * DOM is authoritative: sync from DOM FIRST
     */
  }, {
    key: "handleDeleteKey",
    value: function handleDeleteKey(e) {
      // Check if an image is selected first
      var selectedImage = document.querySelector('.create-post .body figure.selected');
      if (selectedImage) {
        e.preventDefault();
        this.deleteSelectedImage(selectedImage);
        return;
      }
      var selection = window.getSelection();
      if (!selection.rangeCount) return;
      var range = selection.getRangeAt(0);
      var focusedBlock = this.getFocusedBlock();
      if (!focusedBlock) return;
      var blockType = focusedBlock.getAttribute('data-block-type');

      // Highlighted text is removed by the browser. Structural merge/delete
      // applies only to a collapsed caret.
      if (!range.collapsed) {
        return;
      }

      // If cursor is at the end of a paragraph block
      if (blockType === 'paragraph' && range.collapsed) {
        var cursorOffset = this.getTextOffsetInBlock(focusedBlock, selection);
        var blockText = (focusedBlock.textContent || '').replace(/\u200B/g, '');
        var isAtEnd = cursorOffset >= blockText.length;
        if (isAtEnd) {
          e.preventDefault();
          var editor = focusedBlock.parentNode;
          var allBlocks = Array.from(editor.querySelectorAll('[data-block-id]'));
          // A2: Order derived from DOM position, not cached index
          var blockIndex = allBlocks.indexOf(focusedBlock);
          var nextBlockIndex = blockIndex + 1;
          if (nextBlockIndex >= allBlocks.length) {
            return;
          }
          var nextBlockEl = allBlocks[nextBlockIndex];
          if (!nextBlockEl) return;
          var nextBlockType = nextBlockEl.getAttribute('data-block-type');
          if (nextBlockType === 'image' || nextBlockType === 'rawhtml') {
            // Delete the next block from DOM
            nextBlockEl.remove();
            this.updatePlaceholderVisibility();

            // Keep cursor at the end of the current block synchronously
            var newRange = document.createRange();
            var newSelection = window.getSelection();
            var textNode = focusedBlock.firstChild;
            if (textNode && textNode.nodeType === Node.TEXT_NODE) {
              newRange.setStart(textNode, textNode.textContent.length);
              newRange.setEnd(textNode, textNode.textContent.length);
            } else {
              newRange.setStart(focusedBlock, 0);
              newRange.setEnd(focusedBlock, 0);
            }
            newSelection.removeAllRanges();
            newSelection.addRange(newRange);
            focusedBlock.focus();
            return;
          } else if (nextBlockType === 'paragraph' || nextBlockType === 'heading') {
            // Move nodes so <br> soft breaks survive the merge.
            var firstMoved = this._moveChildNodes(focusedBlock, nextBlockEl);
            nextBlockEl.remove();
            this.updatePlaceholderVisibility();

            // Keep cursor at the join. normalize() preserves that caret.
            var _newRange12 = document.createRange();
            var _newSelection1 = window.getSelection();
            if (firstMoved && firstMoved.parentNode === focusedBlock) {
              if (firstMoved.nodeType === Node.TEXT_NODE) {
                _newRange12.setStart(firstMoved, 0);
              } else {
                _newRange12.setStartBefore(firstMoved);
              }
            } else if (focusedBlock.lastChild && focusedBlock.lastChild.nodeType === Node.TEXT_NODE) {
              var end = focusedBlock.lastChild.textContent.length;
              _newRange12.setStart(focusedBlock.lastChild, end);
            } else {
              var caretAnchor = document.createTextNode("\u200B");
              focusedBlock.appendChild(caretAnchor);
              _newRange12.setStart(caretAnchor, 0);
            }
            _newRange12.collapse(true);
            _newSelection1.removeAllRanges();
            _newSelection1.addRange(_newRange12);
            focusedBlock.normalize();
            focusedBlock.focus();
            return;
          }
        }
      } else if (focusedBlock.getAttribute('data-block-type') === 'image') {
        // If an image block is somehow focused, delete it from DOM
        e.preventDefault();
        focusedBlock.remove();
        this.updatePlaceholderVisibility();
        return;
      }
      // Allow default browser behavior for other cases
    }

    /**
     * Structural conversion is Enter-authoritative to ensure deterministic behavior.
     * No structural conversion occurs during input events to avoid race conditions,
     * empty blocks, stale selection, and cursor jumps.
     *
     * All structural conversion (headings, lists, blockquotes) is handled in handleEnterKey() only.
     */
  }, {
    key: "checkAutoConversion",
    value: function checkAutoConversion(e) {
      // Structural conversion is handled on Enter only.
      // This function is kept as a placeholder for potential future non-structural conversions.
      return false;
    }

    /**
     * Handle input events - update document model
     * DOM is authoritative: always read from DOM to update state
     */
  }, {
    key: "handleEditorInput",
    value: function handleEditorInput(e) {
      // Structural conversion is Enter-authoritative - no conversion during input events
      // checkAutoConversion() is now a no-op; all conversion happens in handleEnterKey()

      var focusedBlock = this.getFocusedBlock();
      if (!focusedBlock) return;

      // Schedule serialization (reads from DOM)
      // This respects IME composition state and save thresholds
      this.scheduleSerialization();

      // Update placeholder visibility immediately when user types
      this.updatePlaceholderVisibility();

      // Update next step button state
      this.updateNextStepButton();

      // Auto-scroll to keep caret visible
      this.autoScrollToCaret();
    }

    /**
     * Auto-scroll editor container to keep caret visible
     * Only scrolls when caret is near or past viewport edges
     */
  }, {
    key: "autoScrollToCaret",
    value: function autoScrollToCaret() {
      var selection = window.getSelection();
      if (!selection.rangeCount) return;
      var range = selection.getRangeAt(0);

      // Don't scroll if selection spans multiple lines
      if (!range.collapsed) {
        // Check if selection spans multiple blocks
        var startBlock = range.startContainer.nodeType === Node.TEXT_NODE ? range.startContainer.parentElement.closest('[data-block-id]') : range.startContainer.closest('[data-block-id]');
        var endBlock = range.endContainer.nodeType === Node.TEXT_NODE ? range.endContainer.parentElement.closest('[data-block-id]') : range.endContainer.closest('[data-block-id]');
        if (startBlock !== endBlock) {
          return; // Multi-block selection, don't auto-scroll
        }
      }

      // Get caret position
      var caretRect = range.getBoundingClientRect();

      // Get editor container (scrollable wrapper)
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return;
      var container = editor.closest('.body-field');
      if (!container) return;
      var containerRect = container.getBoundingClientRect();

      // Calculate distances from caret to container edges
      var caretTop = caretRect.top;
      var caretBottom = caretRect.bottom;
      var containerTop = containerRect.top;
      var containerBottom = containerRect.bottom;
      var threshold = 48; // ~48px threshold

      // Check if caret is near or past bottom edge
      if (caretBottom >= containerBottom - threshold) {
        // Scroll down incrementally - just enough to bring caret into comfortable view
        var scrollDelta = caretBottom - (containerBottom - threshold);
        // Add a bit more to keep caret comfortably visible
        container.scrollTop += scrollDelta + threshold;
      }
      // Check if caret is above container top
      else if (caretTop < containerTop) {
        // Scroll up incrementally - just enough to bring caret into view
        var _scrollDelta = containerTop - caretTop;
        // Add a bit more to keep caret comfortably visible
        container.scrollTop -= _scrollDelta + threshold;
      }
      // Caret is comfortably visible, no scrolling needed
    }

    /**
     * Handle paste events - support images and text.
     * Text paste replays content line-by-line through existing insert + Enter logic so that
     * normalization, block creation, and link conversion stay invariant-safe.
     */
  }, {
    key: "handlePaste",
    value: function () {
      var _handlePaste = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
        var _this10 = this;
        var clipboardData, items, imageItem, file, text, lines, syntheticEnter, mergedLines, i, chunk, lineStartsWithListMarker, stripListMarker, _i4, line, focusedBlock, blockType, inList, parts, j, sel, r, br;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              clipboardData = e.clipboardData || window.clipboardData;
              if (clipboardData) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              // Check for image in clipboard
              items = Array.from(clipboardData.items);
              imageItem = items.find(function (item) {
                return item.type.startsWith('image/');
              });
              if (!imageItem) {
                _context8.n = 3;
                break;
              }
              e.preventDefault();
              file = imageItem.getAsFile();
              _context8.n = 2;
              return this.insertImageAtCursor(file);
            case 2:
              setTimeout(function () {
                _this10.autoScrollToCaret();
              }, 0);
              return _context8.a(2);
            case 3:
              // Text paste: replay as typing + Enter. Never parse Markdown or create structure here.
              text = clipboardData.getData('text/plain');
              if (!(text == null)) {
                _context8.n = 4;
                break;
              }
              return _context8.a(2);
            case 4:
              e.preventDefault();

              // Reuse same invariant recovery as Enter: caret must be inside a block.
              if (this._ensureFocusedBlock()) {
                _context8.n = 5;
                break;
              }
              return _context8.a(2);
            case 5:
              lines = text.split(/\r?\n/);
              syntheticEnter = {
                preventDefault: function preventDefault() {}
              }; // Merge lines connected by markdown hard breaks (two trailing spaces)
              mergedLines = [];
              for (i = 0; i < lines.length; i++) {
                chunk = lines[i];
                while (/  $/.test(chunk) && i + 1 < lines.length && lines[i + 1].length > 0) {
                  chunk += '\n' + lines[++i];
                }
                mergedLines.push(chunk);
              }

              // List context must be preserved across pasted lines so list items continue in the same list
              // (Markdown lists are context-dependent; Enter already handles continuation when typing).
              lineStartsWithListMarker = function lineStartsWithListMarker(line) {
                return line.length >= 2 && (line.startsWith('* ') || line.startsWith('- ') || line.startsWith('+ ')) || /^\d+[.)]\s/.test(line);
              };
              stripListMarker = function stripListMarker(line) {
                if (line.startsWith('* ') || line.startsWith('- ') || line.startsWith('+ ')) return line.slice(2);
                var m = line.match(/^(\d+[.)]\s)(.*)$/);
                return m ? m[2] : line;
              };
              for (_i4 = 0; _i4 < mergedLines.length; _i4++) {
                line = mergedLines[_i4];
                focusedBlock = this.getFocusedBlock();
                blockType = focusedBlock ? focusedBlock.getAttribute('data-block-type') : null;
                inList = blockType === 'list-item';
                if (inList && lineStartsWithListMarker(line)) {
                  // Insert content only (no marker) so existing list item gets correct text; Enter will create next item.
                  if (stripListMarker(line).length > 0) {
                    document.execCommand('insertText', false, stripListMarker(line));
                  }
                } else {
                  if (inList && line.length > 0) {
                    // Exit list first so the line becomes a new paragraph, not a list item.
                    this.handleEnterKey(syntheticEnter);
                  }
                  if (line.length > 0) {
                    if (line.includes('\n')) {
                      parts = line.split('\n');
                      for (j = 0; j < parts.length; j++) {
                        if (parts[j].length > 0) {
                          document.execCommand('insertText', false, parts[j]);
                        }
                        if (j < parts.length - 1) {
                          sel = window.getSelection();
                          if (sel.rangeCount) {
                            r = sel.getRangeAt(0);
                            br = document.createElement('br');
                            r.insertNode(br);
                            r.setStartAfter(br);
                            r.collapse(true);
                            sel.removeAllRanges();
                            sel.addRange(r);
                          }
                        }
                      }
                    } else {
                      document.execCommand('insertText', false, line);
                    }
                  }
                }
                if (_i4 < mergedLines.length - 1) {
                  this.handleEnterKey(syntheticEnter);
                }
              }

              // DOM repair: blockquote must never be a child of <ul> (paste can create list+blockquote structure)
              this._ensureBlockquoteNotInList();
              this.scheduleSerialization();
              this.updatePlaceholderVisibility();
              this.autoScrollToCaret();
            case 6:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function handlePaste(_x3) {
        return _handlePaste.apply(this, arguments);
      }
      return handlePaste;
    }()
    /**
     * Handle drag over - show insertion indicator and store insertion point as single source of truth
     */
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e) {
      e.preventDefault();
      e.stopPropagation();

      // Check if dragging files
      if (!e.dataTransfer.types.includes('Files')) {
        return;
      }
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return;
      this.isDragging = true;

      // Find insertion point for visual indicator - this is the single source of truth
      var insertionPoint = this.findInsertionPoint(e.clientY);
      if (insertionPoint) {
        // Store the insertion point that matches the visual indicator
        // Update on every dragover so it always matches the current indicator position
        // This ensures the drop position matches where the indicator is when drop happens
        this.storedInsertionPoint = {
          position: insertionPoint.position,
          element: insertionPoint.element,
          index: insertionPoint.index,
          // Document model index, not DOM index
          splitBlock: insertionPoint.splitBlock ? _objectSpread({}, insertionPoint.splitBlock) : null
        };

        // Show visual indicator at this exact position (only moves if position changed)
        this.showInsertionIndicator(insertionPoint);
      } else {
        // If insertionPoint is null, clear stored point to avoid stale data
        // This shouldn't happen in normal flow, but protects against edge cases
        this.storedInsertionPoint = null;
        this.removeInsertionIndicators();
      }
      e.dataTransfer.dropEffect = 'copy';
    }

    /**
     * Handle drag leave - remove insertion indicator (but keep stored insertion point)
     */
  }, {
    key: "handleDragLeave",
    value: function handleDragLeave(e) {
      // Only remove if we're leaving the editor entirely
      var editor = document.querySelector('#stack-post-body-editor');
      if (editor && !editor.contains(e.relatedTarget)) {
        this.removeInsertionIndicators();
        this.isDragging = false;
        // DO NOT clear storedInsertionPoint here - keep it frozen until drop
      }
    }

    /**
     * Handle drop - insert image at drop point using stored insertion point (single source of truth)
     */
  }, {
    key: "handleDrop",
    value: function () {
      var _handleDrop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(e) {
        var files, storedInsertionPoint;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              e.preventDefault();
              e.stopPropagation();
              this.removeInsertionIndicators();
              this.isDragging = false;
              files = Array.from(e.dataTransfer.files).filter(function (file) {
                return file.type.startsWith('image/');
              });
              if (!(files.length === 0)) {
                _context9.n = 1;
                break;
              }
              this.storedInsertionPoint = null;
              this.storedDropRange = null;
              return _context9.a(2);
            case 1:
              // Use the STORED INSERTION POINT as single source of truth
              // This matches exactly what the visual indicator showed
              storedInsertionPoint = this.storedInsertionPoint;
              this.storedInsertionPoint = null; // Clear after use
              this.storedDropRange = null; // Clear legacy reference

              // The indicator was in the editor while the index was captured. Recompute
              // from the real block now that the indicator is gone, so a child-list
              // index that included the line cannot shift the image by one block.
              if (storedInsertionPoint && storedInsertionPoint.element && storedInsertionPoint.element.isConnected) {
                storedInsertionPoint.index = this.insertionIndexForElement(storedInsertionPoint.position, storedInsertionPoint.element, storedInsertionPoint.index);
              }
              if (storedInsertionPoint) {
                _context9.n = 3;
                break;
              }
              // Fallback: if no stored insertion point, use end of document
              console.warn('No stored insertion point, inserting at end');
              _context9.n = 2;
              return this.insertImageAtCursor(files[0], null);
            case 2:
              return _context9.a(2);
            case 3:
              _context9.n = 4;
              return this.insertImageAtCursor(files[0], storedInsertionPoint);
            case 4:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function handleDrop(_x4) {
        return _handleDrop.apply(this, arguments);
      }
      return handleDrop;
    }()
    /**
     * Editor children that are real blocks. The insertion line is mounted in the
     * editor while dragging; counting it shifts every later index by one.
     */
  }, {
    key: "editorContentChildren",
    value: function editorContentChildren(editor) {
      return Array.from(editor.children).filter(function (el) {
        return !(el.classList && el.classList.contains('insertion-indicator'));
      });
    }

    /**
     * Next sibling that is not the insertion line.
     */
  }, {
    key: "nextContentSibling",
    value: function nextContentSibling(node) {
      var sib = node;
      while (sib && sib.nodeType === Node.ELEMENT_NODE && sib.classList.contains('insertion-indicator')) {
        sib = sib.nextSibling;
      }
      return sib;
    }

    /**
     * Index in the [data-block-id] list, which is what image insertion uses.
     * `position: 'after'` is already the slot after the element.
     * Falls back to siblingIndex when the element is not itself a block (a ul).
     */
  }, {
    key: "insertionIndexForElement",
    value: function insertionIndexForElement(position, element, siblingIndex) {
      if (!element) return siblingIndex;
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return siblingIndex;
      var blocks = Array.from(editor.querySelectorAll('[data-block-id]'));
      var idx = blocks.indexOf(element);
      if (idx < 0) return siblingIndex;
      if (position === 'after') return idx + 1;
      return idx;
    }

    /**
     * Find insertion point based on Y coordinate
     * Handles both between blocks and within blocks (e.g., between <br> tags)
     */
  }, {
    key: "findInsertionPoint",
    value: function findInsertionPoint(clientY) {
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return null;
      var blocks = this.editorContentChildren(editor);
      if (blocks.length === 0) return {
        position: 'before',
        element: null,
        index: 0,
        splitBlock: null
      };

      // Check if we're before the first block
      if (blocks.length > 0) {
        var firstBlock = blocks[0];
        var firstRect = firstBlock.getBoundingClientRect();
        if (clientY < firstRect.top) {
          return {
            position: 'before',
            element: firstBlock,
            index: this.insertionIndexForElement('before', firstBlock, 0),
            splitBlock: null
          };
        }
      }

      // First, check if we're over a paragraph block that might contain <br> tags
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        var rect = block.getBoundingClientRect();

        // Check if Y coordinate is within this block
        if (clientY >= rect.top && clientY <= rect.bottom) {
          var blockType = block.getAttribute('data-block-type');

          // A2: Order derived from DOM position (loop index), not cached index.
          // Map onto the data-block list so the insertion line cannot inflate it.
          var blockIndex = this.insertionIndexForElement('before', block, i);

          // For paragraph blocks, check if we're over a line break area
          if (blockType === 'paragraph') {
            var splitPoint = this.findSplitPointInBlock(block, clientY);
            if (splitPoint) {
              return {
                position: 'split',
                element: block,
                index: blockIndex,
                splitBlock: splitPoint
              };
            }
          }

          // If we're in the upper half, insert before
          var blockMiddle = rect.top + rect.height / 2;
          if (clientY < blockMiddle) {
            return {
              position: 'before',
              element: block,
              index: blockIndex,
              splitBlock: null
            };
          } else {
            // In lower half, insert after
            return {
              position: 'after',
              element: block,
              index: this.insertionIndexForElement('after', block, i + 1),
              splitBlock: null
            };
          }
        }

        // Check if we're in a gap BETWEEN blocks (not inside any block)
        // If we're past the current block's bottom but before the next block's top
        if (i < blocks.length - 1) {
          var nextBlock = blocks[i + 1];
          var nextRect = nextBlock.getBoundingClientRect();

          // If mouse is between current block bottom and next block top
          if (clientY > rect.bottom && clientY < nextRect.top) {
            // Gap includes the insertion line, which is not a block.
            return {
              position: 'after',
              element: block,
              index: this.insertionIndexForElement('after', block, i + 1),
              splitBlock: null
            };
          }
        }
      }

      // After last block - use DOM position
      var lastBlock = blocks[blocks.length - 1];
      var lastIndex = blocks.length - 1;
      return {
        position: 'after',
        element: lastBlock,
        index: this.insertionIndexForElement('after', lastBlock, lastIndex + 1),
        splitBlock: null
      };
    }

    /**
     * Find split point from a Range within a block
     * @param {Element} block - Block element
     * @param {Node} container - Container node from Range
     * @param {number} offset - Offset in container
     * @returns {Object|null} Split information or null
     */
  }, {
    key: "findSplitPointInBlockFromRange",
    value: function findSplitPointInBlockFromRange(block, container, offset) {
      if (!block || !container) return null;

      // Check if we're at or near a <br> element
      var node = container;
      if (container.nodeType === Node.TEXT_NODE) {
        node = container.parentNode;
      }

      // Walk to find <br> elements
      var brElements = Array.from(block.querySelectorAll('br'));
      for (var _i5 = 0, _brElements = brElements; _i5 < _brElements.length; _i5++) {
        var br = _brElements[_i5];
        var range = document.createRange();
        range.setStart(block, 0);
        range.setEndBefore(br);
        var beforeText = range.toString();
        range.setStartAfter(br);
        range.setEnd(block, block.childNodes.length);
        var afterText = range.toString();

        // Check if our offset is near this <br>
        var beforeLength = beforeText.length;
        if (Math.abs(offset - beforeLength) < 2) {
          return {
            brNode: br,
            beforeText: beforeText.trim(),
            afterText: afterText.trim()
          };
        }
      }
      return null;
    }

    /**
     * Find if we should split a block at a line break area
     * Returns split information if we're over a <br> area or blank line, null otherwise
     */
  }, {
    key: "findSplitPointInBlock",
    value: function findSplitPointInBlock(block, clientY) {
      var rect = block.getBoundingClientRect();

      // Try to use caretRangeFromPoint or caretPositionFromPoint to find exact position
      var range = null;
      if (document.caretRangeFromPoint) {
        range = document.caretRangeFromPoint(clientY, rect.left + rect.width / 2);
      } else if (document.caretPositionFromPoint) {
        var pos = document.caretPositionFromPoint(clientY, rect.left + rect.width / 2);
        if (pos) {
          range = document.createRange();
          range.setStart(pos.offsetNode, pos.offset);
          range.setEnd(pos.offsetNode, pos.offset);
        }
      }

      // If we got a range, use it to find split point
      if (range && range.startContainer) {
        var container = range.startContainer;
        var splitNode = null;
        var offset = range.startOffset;

        // If container is the block itself, find the child node at that offset
        if (container === block) {
          if (block.childNodes[offset]) {
            splitNode = block.childNodes[offset];
          } else if (offset > 0 && block.childNodes[offset - 1]) {
            splitNode = block.childNodes[offset - 1];
          }
        } else {
          // Container is a child node
          splitNode = container;
        }

        // Check if we're at or near a <br> element
        if (splitNode && splitNode.tagName === 'BR') {
          var beforeText = this.getTextBeforeNode(block, splitNode);
          var afterText = this.getTextAfterNode(block, splitNode);
          return {
            brNode: splitNode,
            beforeText: beforeText.trim(),
            afterText: afterText.trim()
          };
        }

        // If we're in a text node, find the nearest <br> or line break
        if (splitNode && splitNode.nodeType === Node.TEXT_NODE) {
          // Walk backwards to find previous <br>
          var prevNode = splitNode.previousSibling;
          while (prevNode) {
            if (prevNode.tagName === 'BR') {
              var _beforeText = this.getTextBeforeNode(block, prevNode);
              var _afterText = this.getTextAfterNode(block, prevNode);
              return {
                brNode: prevNode,
                beforeText: _beforeText.trim(),
                afterText: _afterText.trim()
              };
            }
            prevNode = prevNode.previousSibling;
          }

          // Walk forwards to find next <br>
          var nextNode = splitNode.nextSibling;
          while (nextNode) {
            if (nextNode.tagName === 'BR') {
              var _beforeText2 = this.getTextBeforeNode(block, nextNode);
              var _afterText2 = this.getTextAfterNode(block, nextNode);
              return {
                brNode: nextNode,
                beforeText: _beforeText2.trim(),
                afterText: _afterText2.trim()
              };
            }
            nextNode = nextNode.nextSibling;
          }

          // No <br> found, but we can still split at the text position
          var fullText = block.textContent || '';
          var charPos = 0;

          // Calculate character position
          var walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, null);
          var textNode = walker.nextNode();
          while (textNode && textNode !== splitNode) {
            charPos += textNode.textContent.length;
            textNode = walker.nextNode();
          }
          if (textNode === splitNode) {
            charPos += offset;
          }
          var _beforeText3 = fullText.substring(0, charPos).trim();
          var _afterText3 = fullText.substring(charPos).trim();
          if (_beforeText3 || _afterText3) {
            return {
              brNode: null,
              beforeText: _beforeText3,
              afterText: _afterText3,
              estimated: true
            };
          }
        }
      }

      // Fallback: check all <br> elements
      var brElements = Array.from(block.querySelectorAll('br'));
      var closestBr = null;
      var closestDistance = Infinity;
      for (var _i6 = 0, _brElements2 = brElements; _i6 < _brElements2.length; _i6++) {
        var br = _brElements2[_i6];
        var brRect = br.getBoundingClientRect();
        var brY = brRect.top + brRect.height / 2;
        var distance = Math.abs(clientY - brY);
        if (distance < closestDistance && distance < 30) {
          closestDistance = distance;
          closestBr = br;
        }
      }
      if (closestBr) {
        var _beforeText4 = this.getTextBeforeNode(block, closestBr);
        var _afterText4 = this.getTextAfterNode(block, closestBr);
        return {
          brNode: closestBr,
          beforeText: _beforeText4.trim(),
          afterText: _afterText4.trim()
        };
      }
      return null;
    }

    /**
     * Get text content before a specific node within a block
     */
  }, {
    key: "getTextBeforeNode",
    value: function getTextBeforeNode(block, targetNode) {
      var range = document.createRange();
      range.setStart(block, 0);
      range.setEndBefore(targetNode);
      return range.toString();
    }

    /**
     * Get text content after a specific node within a block
     */
  }, {
    key: "getTextAfterNode",
    value: function getTextAfterNode(block, targetNode) {
      var range = document.createRange();
      range.setStartAfter(targetNode);
      range.setEnd(block, block.childNodes.length);
      return range.toString();
    }

    /**
     * Show insertion indicator between blocks or at split point
     * Optimized to only move indicator when position actually changes
     */
  }, {
    key: "showInsertionIndicator",
    value: function showInsertionIndicator(insertionPoint) {
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor || !insertionPoint) return;
      var indicator = document.querySelector('.insertion-indicator');
      if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = 'insertion-indicator';
        editor.appendChild(indicator);
      }

      // Determine where the indicator should be
      var targetSibling = null;
      if (insertionPoint.position === 'split' && insertionPoint.splitBlock && insertionPoint.element) {
        // Show indicator after the block that will be split
        var block = insertionPoint.element;
        targetSibling = this.nextContentSibling(block.nextSibling);
      } else if (insertionPoint.position === 'before' && insertionPoint.element) {
        targetSibling = insertionPoint.element;
      } else if (insertionPoint.position === 'after' && insertionPoint.element) {
        targetSibling = this.nextContentSibling(insertionPoint.element.nextSibling);
      } else if (insertionPoint.position === 'before' && !insertionPoint.element) {
        // First block (no element means before first)
        targetSibling = this.nextContentSibling(editor.firstChild);
      } else {
        // Fallback: append to end
        targetSibling = null;
      }

      // Only move indicator if it's not already in the correct position
      // Check if indicator's nextSibling matches the target
      var currentNextSibling = indicator.nextSibling;
      if (currentNextSibling !== targetSibling) {
        if (targetSibling && targetSibling !== indicator) {
          // Only move if target is not the indicator itself (prevents infinite loops)
          editor.insertBefore(indicator, targetSibling);
        } else if (targetSibling === null) {
          // No target sibling means append to end
          // Only move if indicator is not already at the end
          if (indicator.parentNode !== editor || indicator.nextSibling !== null) {
            editor.appendChild(indicator);
          }
        }
      }
    }

    /**
     * Remove insertion indicators
     */
  }, {
    key: "removeInsertionIndicators",
    value: function removeInsertionIndicators() {
      var indicators = document.querySelectorAll('.insertion-indicator');
      indicators.forEach(function (indicator) {
        return indicator.remove();
      });
    }

    /**
     * Insert image at cursor position or drop point
     * @param {File} file - Image file to insert
     * @param {Object|null} dropPosition - Stored insertionPoint object (single source of truth), or null for cursor
     */
  }, {
    key: "insertImageAtCursor",
    value: function () {
      var _insertImageAtCursor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(file) {
        var dropPosition,
          dataUrl,
          imageDataUrl,
          base64Data,
          insertIndex,
          needsBlockSplit,
          splitInfo,
          blockToSplitIndex,
          focusedBlock,
          _editor0,
          _allBlocks2,
          blockIndex,
          selection,
          range,
          cursorOffset,
          _editor1,
          editor,
          blockCount,
          _allBlocks3,
          blockToSplitEl,
          afterBlockEl,
          afterBlockId,
          imageElement,
          imageBlockId,
          img,
          imageId,
          parts,
          meta,
          imageBase64,
          mimeMatch,
          mime,
          allBlocks,
          insertAtEnd,
          newParagraphElement,
          newParagraphId,
          targetBlock,
          insertBeforeElement,
          newRange,
          newSelection,
          textNode,
          nextBlock,
          editorEl,
          _args0 = arguments,
          _t5;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              dropPosition = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : null;
              if (!(!file || !file.type.startsWith('image/'))) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              _context0.n = 2;
              return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  return resolve(e.target.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
              });
            case 2:
              dataUrl = _context0.v;
              // Optionally resize image (using existing infrastructure)
              imageDataUrl = dataUrl;
              if (!(this.app.browser && this.app.browser.resizeImg)) {
                _context0.n = 6;
                break;
              }
              _context0.p = 3;
              _context0.n = 4;
              return this.app.browser.resizeImg(dataUrl);
            case 4:
              imageDataUrl = _context0.v;
              _context0.n = 6;
              break;
            case 5:
              _context0.p = 5;
              _t5 = _context0.v;
              console.warn('Image resize failed, using original:', _t5);
            case 6:
              // Extract base64 data (for storage)
              base64Data = imageDataUrl.split(',')[1] || ''; // Determine insertion index using stored insertion point (single source of truth)
              // Default to end only if we have no position information
              insertIndex = -1; // Use -1 to indicate "not set" - we'll validate later
              needsBlockSplit = false;
              splitInfo = null;
              blockToSplitIndex = -1;
              if (dropPosition) {
                // Use stored insertion point - this matches exactly what the visual indicator showed
                // dropPosition is the storedInsertionPoint object with: position, element, index, splitBlock
                insertIndex = dropPosition.index;
                blockToSplitIndex = dropPosition.index;
                if (dropPosition.position === 'split' && dropPosition.splitBlock) {
                  needsBlockSplit = true;
                  splitInfo = dropPosition.splitBlock;
                  // When splitting, insert after the split (at index + 1)
                  insertIndex = dropPosition.index + 1;
                } else if (dropPosition.position === 'before') {
                  // Insert before the element at this index
                  insertIndex = dropPosition.index;
                } else if (dropPosition.position === 'after') {
                  // Insert after the element at this index
                  insertIndex = dropPosition.index;
                }
              } else {
                // Cursor position (no drop position provided)
                focusedBlock = this.getFocusedBlock();
                if (focusedBlock) {
                  // Get all blocks in DOM order (A2: Order derived from DOM position)
                  _editor0 = document.querySelector('#stack-post-body-editor');
                  if (_editor0) {
                    _allBlocks2 = Array.from(_editor0.querySelectorAll('[data-block-id]'));
                    blockIndex = _allBlocks2.indexOf(focusedBlock);
                    if (blockIndex >= 0) {
                      // Get cursor position within the block to determine insertion point
                      selection = window.getSelection();
                      if (selection.rangeCount > 0) {
                        range = selection.getRangeAt(0);
                        cursorOffset = this.getTextOffsetInBlock(focusedBlock, selection); // If cursor is at the start of the block (offset 0), insert before it
                        // This allows images to be inserted at index 0 (first element)
                        if (cursorOffset === 0) {
                          insertIndex = blockIndex; // Insert before current block
                        } else {
                          // If cursor is at end or middle, insert after the block
                          insertIndex = blockIndex + 1;
                        }
                      } else {
                        // No selection, default to after the block
                        insertIndex = blockIndex + 1;
                      }
                    } else {
                      // Block not found, insert at end
                      insertIndex = _allBlocks2.length;
                    }
                  } else {
                    // No editor, should not happen but default to 0
                    insertIndex = 0;
                  }
                } else {
                  // No focused block, insert at end
                  _editor1 = document.querySelector('#stack-post-body-editor');
                  if (_editor1) {
                    insertIndex = this.getBlockCount();
                  } else {
                    insertIndex = 0;
                  }
                }
              }

              // Get editor reference
              editor = document.querySelector('#stack-post-body-editor');
              if (editor) {
                _context0.n = 7;
                break;
              }
              return _context0.a(2);
            case 7:
              // Validate insertIndex - clamp to valid range
              blockCount = this.getBlockCount();
              if (insertIndex < 0) {
                insertIndex = blockCount;
              } else if (insertIndex > blockCount) {
                // If index is beyond document length, clamp to end
                insertIndex = blockCount;
              }

              // If we need to split a block, do it first in DOM
              if (needsBlockSplit && splitInfo && blockToSplitIndex >= 0 && blockToSplitIndex < blockCount) {
                _allBlocks3 = Array.from(editor.querySelectorAll('[data-block-id]'));
                blockToSplitEl = _allBlocks3[blockToSplitIndex];
                if (blockToSplitEl && blockToSplitEl.getAttribute('data-block-type') === 'paragraph') {
                  if (blockToSplitEl) {
                    // Update the original block with text before the split
                    blockToSplitEl.textContent = splitInfo.beforeText.trim();

                    // Create a new paragraph block with text after the split in DOM
                    afterBlockEl = document.createElement('p');
                    afterBlockId = generateBlockId(this.getBlockCount());
                    afterBlockEl.setAttribute('data-block-id', afterBlockId);
                    afterBlockEl.setAttribute('data-block-type', 'paragraph');
                    afterBlockEl.contentEditable = 'true';
                    afterBlockEl.textContent = splitInfo.afterText.trim();

                    // Insert after the split block
                    if (blockToSplitEl.nextSibling) {
                      editor.insertBefore(afterBlockEl, blockToSplitEl.nextSibling);
                    } else {
                      editor.appendChild(afterBlockEl);
                    }
                    // insertIndex remains correct for the image (after the new after-block)
                  }
                }
              }

              // Create image element in DOM
              imageElement = document.createElement('figure');
              imageBlockId = generateBlockId(this.getBlockCount());
              imageElement.setAttribute('data-block-id', imageBlockId);
              imageElement.setAttribute('data-block-type', 'image');
              imageElement.className = 'image-block';
              imageElement.contentEditable = false;
              img = document.createElement('img');
              img.src = imageDataUrl;
              img.alt = file.name || '';
              imageElement.appendChild(img);

              // ----------------------------------------------------
              // REGISTER IMAGE IN EDITOR STATE
              // ----------------------------------------------------

              // Ensure image registry exists
              this.images = Array.isArray(this.images) ? this.images : [];

              // Assign stable image ID
              imageId = "img_".concat(this.images.length); // Extract mime + base64 (do NOT reuse existing base64Data variable)
              parts = imageDataUrl.split(',');
              meta = parts[0];
              imageBase64 = parts[1];
              mimeMatch = meta.match(/data:(.*?);base64/);
              mime = mimeMatch ? mimeMatch[1] : 'image/png'; // Store image payload
              this.images.push({
                id: imageId,
                mime: mime,
                data: imageBase64
              });

              // Stamp ID onto DOM node for serialization
              img.dataset.stackImageId = imageId;

              // Insert into DOM at the correct position
              // Images are always direct children of the editor, not nested
              // Get all blocks to find the correct insertion point relative to editor's direct children
              allBlocks = Array.from(editor.querySelectorAll('[data-block-id]'));
              insertAtEnd = insertIndex >= allBlocks.length; // [IMAGE INSERT] Temporary logging: insertion position and at-end decision
              console.log('[IMAGE INSERT] insertIndex=', insertIndex, 'allBlocks.length=', allBlocks.length, 'insertAtEnd=', insertAtEnd);

              // Only create a new paragraph when inserting at end of document (no following block).
              // When inserting before an existing block, do NOT add a paragraph — leave structure intact.
              newParagraphElement = null;
              if (insertAtEnd) {
                newParagraphElement = document.createElement('p');
                newParagraphId = generateBlockId(this.getBlockCount() + 1);
                newParagraphElement.setAttribute('data-block-id', newParagraphId);
                newParagraphElement.setAttribute('data-block-type', 'paragraph');
                newParagraphElement.contentEditable = 'true';
                newParagraphElement.textContent = '';
                newParagraphElement.appendChild(document.createTextNode("\u200B"));
              }
              if (insertIndex <= 0) {
                // Insert at the beginning (index 0) - insert as first child
                if (editor.firstChild) {
                  editor.insertBefore(imageElement, editor.firstChild);
                } else {
                  editor.appendChild(imageElement);
                }
                if (newParagraphElement) {
                  if (imageElement.nextSibling) {
                    editor.insertBefore(newParagraphElement, imageElement.nextSibling);
                  } else {
                    editor.appendChild(newParagraphElement);
                  }
                }
                console.log('[IMAGE INSERT] inserted at start; paragraph auto-created=', !!newParagraphElement);
              } else if (insertAtEnd) {
                // Insert at the end — image then new paragraph
                editor.appendChild(imageElement);
                editor.appendChild(newParagraphElement);
                console.log('[IMAGE INSERT] inserted at end; paragraph auto-created=true');
              } else {
                // Insert before an existing block — image only, no new paragraph
                targetBlock = allBlocks[insertIndex];
                if (targetBlock) {
                  insertBeforeElement = targetBlock;
                  while (insertBeforeElement && insertBeforeElement.parentNode !== editor) {
                    insertBeforeElement = insertBeforeElement.parentNode;
                  }
                  if (insertBeforeElement && insertBeforeElement.parentNode === editor) {
                    editor.insertBefore(imageElement, insertBeforeElement);
                  } else {
                    editor.appendChild(imageElement);
                  }
                } else {
                  editor.appendChild(imageElement);
                }
                console.log('[IMAGE INSERT] inserted before existing block; paragraph auto-created=false');
              }

              // Update placeholder visibility
              this.updatePlaceholderVisibility();

              // Cursor placement: at end → new paragraph; before existing block → start of next block
              newRange = document.createRange();
              newSelection = window.getSelection();
              if (newParagraphElement) {
                textNode = newParagraphElement.firstChild;
                if (textNode && textNode.nodeType === Node.TEXT_NODE) {
                  newRange.setStart(textNode, 0);
                  newRange.setEnd(textNode, 0);
                } else {
                  newRange.setStart(newParagraphElement, 0);
                  newRange.setEnd(newParagraphElement, 0);
                }
                newParagraphElement.focus();
              } else {
                // Place cursor at start of the block immediately after the image (existing content)
                nextBlock = imageElement.nextSibling;
                if (nextBlock) {
                  newRange.setStart(nextBlock, 0);
                  newRange.setEnd(nextBlock, 0);
                  editorEl = document.querySelector('#stack-post-body-editor');
                  if (editorEl && editorEl.focus) editorEl.focus();
                }
              }
              newSelection.removeAllRanges();
              newSelection.addRange(newRange);

              // ========================================================================
              // IMAGE INSERTION MUST TRIGGER AUTOSAVE
              // ========================================================================
              // Image insertion is a document edit - it must mark the document as dirty
              // and trigger autosave logic, just like text edits do.
              // This ensures images persist even if no text changes occur afterward.
              this.scheduleSerialization();
            case 8:
              return _context0.a(2);
          }
        }, _callee0, this, [[3, 5]]);
      }));
      function insertImageAtCursor(_x5) {
        return _insertImageAtCursor.apply(this, arguments);
      }
      return insertImageAtCursor;
    }()
    /**
     * Handle click on image block - toggle selection to show/hide caption
     */
  }, {
    key: "handleImageClick",
    value: function handleImageClick(imageBlock) {
      // Deselect all images first
      this.deselectAllImages();

      // Toggle selection on clicked image
      if (imageBlock.classList.contains('selected')) {
        imageBlock.classList.remove('selected');
      } else {
        imageBlock.classList.add('selected');
      }
    }

    /**
     * Deselect all image blocks
     */
  }, {
    key: "deselectAllImages",
    value: function deselectAllImages() {
      var selectedImages = document.querySelectorAll('.create-post .body figure.selected');
      selectedImages.forEach(function (img) {
        return img.classList.remove('selected');
      });
    }

    /**
     * Update publish trigger visibility based on content (now on Admin element)
     */
  }, {
    key: "updatePublishTriggerVisibility",
    value: function updatePublishTriggerVisibility() {
      var adminElement = document.querySelector('#stack-draft-state');
      if (!adminElement) return;

      // Check if there's meaningful content (read from DOM)
      var editor = document.querySelector('#stack-post-body-editor');
      var hasContent = false;
      if (editor) {
        var blockElements = editor.querySelectorAll('[data-block-id]');
        var _iterator6 = _createForOfIteratorHelper(blockElements),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var blockEl = _step6.value;
            var blockType = blockEl.getAttribute('data-block-type');
            if (blockType === 'paragraph' || blockType === 'heading' || blockType === 'list-item' || blockType === 'blockquote') {
              var text = (blockEl.textContent || '').replace(/\u200B/g, '').trim();
              if (text.length > 0) {
                hasContent = true;
                break;
              }
            } else if (blockType === 'image') {
              hasContent = true;
              break;
            } else if (blockType === 'rawhtml') {
              var html = (blockEl.innerHTML || '').trim();
              if (html.length > 0) {
                hasContent = true;
                break;
              }
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
      if (hasContent) {
        adminElement.classList.add('stack-admin-active');
      } else {
        adminElement.classList.remove('stack-admin-active');
      }
    }

    /**
     * Update publish trigger state (draft/published) - now on Admin element
     */
  }, {
    key: "updatePublishTriggerState",
    value: function updatePublishTriggerState() {
      var adminElement = document.querySelector('#stack-draft-state');
      if (!adminElement) return;
      if (this.isPublished) {
        adminElement.classList.add('stack-admin-published');
        adminElement.setAttribute('title', 'Edit publication');
      } else {
        adminElement.classList.remove('stack-admin-published');
        adminElement.setAttribute('title', 'Publish settings');
      }

      // ISSUE 1 — EDITOR BUTTON TEXT: Update button text based on parent_id
      // If parent_id !== null, this is editing a published post → "Update"
      // If parent_id === null, this is new post or draft → "Publish"
      var publishBtn = document.querySelector('#stack-editor-publish-btn');
      if (publishBtn) {
        if (this.parent_id !== null) {
          publishBtn.textContent = 'Update';
        } else {
          publishBtn.textContent = 'Publish';
        }
      }

      // Update status display to reflect published state (unless currently saving)
      if (this.saveState !== 'saving') {
        this.updateStatusDisplay();
      }
    }

    /**
     * Focus body editor at the end of document content
     * Used when transitioning from title to body (Enter/Tab)
     */
  }, {
    key: "focusBodyEditorAtEnd",
    value: function focusBodyEditorAtEnd() {
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return;

      // Find the last editable block in the document
      var blocks = Array.from(editor.children);
      var targetBlock = null;

      // Work backwards to find the last editable block
      for (var i = blocks.length - 1; i >= 0; i--) {
        var block = blocks[i];
        var blockType = block.getAttribute('data-block-type');

        // Skip non-editable blocks (images, etc.)
        if (blockType === 'paragraph' || blockType === 'heading' || blockType === 'rawhtml') {
          if (block.hasAttribute('contenteditable') && block.getAttribute('contenteditable') === 'true') {
            targetBlock = block;
            break;
          }
        }
      }

      // If no editable block found, use the first block or create one
      if (!targetBlock) {
        targetBlock = editor.querySelector('[contenteditable="true"]');

        // If still no block, ensure we have at least one paragraph in DOM
        if (!targetBlock && this.getBlockCount() === 0) {
          var _require2 = require('../post-document'),
            _generateBlockId = _require2.generateBlockId;
          var newParagraphEl = document.createElement('p');
          var newParagraphId = _generateBlockId(0);
          newParagraphEl.setAttribute('data-block-id', newParagraphId);
          newParagraphEl.setAttribute('data-block-type', 'paragraph');
          newParagraphEl.contentEditable = 'true';
          newParagraphEl.textContent = '';
          newParagraphEl.appendChild(document.createTextNode("\u200B"));
          editor.appendChild(newParagraphEl);
          targetBlock = newParagraphEl;
        }
      }
      if (targetBlock) {
        var range = document.createRange();
        var selection = window.getSelection();

        // Find the last text node in the block
        var lastTextNode = null;
        var walker = document.createTreeWalker(targetBlock, NodeFilter.SHOW_TEXT, null);
        var textNode = walker.nextNode();
        while (textNode) {
          lastTextNode = textNode;
          textNode = walker.nextNode();
        }

        // Place cursor at the end of the last text node
        if (lastTextNode) {
          var textLength = lastTextNode.textContent.replace(/\u200B/g, '').length;
          var actualLength = lastTextNode.textContent.length;
          range.setStart(lastTextNode, actualLength);
          range.setEnd(lastTextNode, actualLength);
        } else {
          // No text node, place at end of block
          if (targetBlock.firstChild) {
            range.setStartAfter(targetBlock.lastChild);
            range.setEndAfter(targetBlock.lastChild);
          } else {
            // Empty block, create text node and place cursor
            var _textNode5 = document.createTextNode("\u200B");
            targetBlock.appendChild(_textNode5);
            range.setStart(_textNode5, 0);
            range.setEnd(_textNode5, 0);
          }
        }
        selection.removeAllRanges();
        selection.addRange(range);
        targetBlock.focus();

        // Smoothly scroll to make the caret visible
        setTimeout(function () {
          var rect = range.getBoundingClientRect();
          var editorRect = editor.getBoundingClientRect();
          var scrollContainer = editor.closest('.body-field');
          if (scrollContainer && rect) {
            // Check if caret is outside viewport
            var isAboveViewport = rect.top < editorRect.top;
            var isBelowViewport = rect.bottom > editorRect.bottom;
            if (isAboveViewport || isBelowViewport) {
              // Calculate scroll position to center the caret
              var scrollTop = scrollContainer.scrollTop;
              var caretRelativeTop = rect.top - editorRect.top + scrollTop;
              var viewportHeight = scrollContainer.clientHeight;
              var targetScroll = caretRelativeTop - viewportHeight / 2;
              scrollContainer.scrollTo({
                top: Math.max(0, targetScroll),
                behavior: 'smooth'
              });
            }
          } else if (targetBlock) {
            // Fallback: scroll the block into view
            targetBlock.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }, 0);
      } else {
        // Fallback: focus the editor itself
        editor.focus();
      }
    }

    /**
     * Handle publish trigger click - open publish settings overlay
     */
  }, {
    key: "handlePublishTriggerClick",
    value: function handlePublishTriggerClick() {
      if (!this.mod.publishSettingsOverlay) {
        var PublishSettingsOverlay = require('./overlay/publish-settings');
        this.mod.publishSettingsOverlay = new PublishSettingsOverlay(this.app, this.mod);
      }

      // Get current post data
      var title = this.getDocumentTitle();
      var editor = document.querySelector('#stack-post-body-editor');
      var content = editor ? this.serializeDOMToMarkdown() : '';

      // Get featured image from editor state
      var featuredImage = this.featuredImage || null;
      this.mod.publishSettingsOverlay.render({
        published: this.isPublished,
        description: content.substring(0, 200).replace(/\n/g, ' ').trim(),
        image: featuredImage,
        imageUrl: null // Featured image is always base64, no URL
      });
    }

    /**
     * Delete a selected image block
     */
  }, {
    key: "deleteSelectedImage",
    value: function deleteSelectedImage(imageElement) {
      var blockId = imageElement.getAttribute('data-block-id');
      if (!blockId) return;

      // Find target element BEFORE removing (to move caret to)
      var editor = document.querySelector('#stack-post-body-editor');
      if (!editor) return;
      var targetElement = null;

      // Try to find a paragraph block after the image
      var nextSibling = imageElement.nextSibling;
      if (nextSibling && nextSibling.hasAttribute && nextSibling.hasAttribute('contenteditable')) {
        targetElement = nextSibling;
      }

      // If no block after, try the one before
      if (!targetElement) {
        var prevSibling = imageElement.previousSibling;
        if (prevSibling && prevSibling.hasAttribute && prevSibling.hasAttribute('contenteditable')) {
          targetElement = prevSibling;
        }
      }

      // Remove the image block from DOM
      imageElement.remove();

      // Update placeholder visibility
      this.updatePlaceholderVisibility();

      // If still no block, create a new empty paragraph in DOM
      if (!targetElement) {
        var _require3 = require('../post-document'),
          _generateBlockId2 = _require3.generateBlockId;
        var newParagraphEl = document.createElement('p');
        var newParagraphId = _generateBlockId2(this.getBlockCount());
        newParagraphEl.setAttribute('data-block-id', newParagraphId);
        newParagraphEl.setAttribute('data-block-type', 'paragraph');
        newParagraphEl.contentEditable = 'true';
        newParagraphEl.textContent = '';
        newParagraphEl.appendChild(document.createTextNode("\u200B"));
        editor.appendChild(newParagraphEl);
        targetElement = newParagraphEl;
      }

      // Focus the target block synchronously
      if (targetElement && targetElement.hasAttribute('contenteditable')) {
        var range = document.createRange();
        var selection = window.getSelection();

        // Place cursor at the end of the block if it's a paragraph/heading
        var blockType = targetElement.getAttribute('data-block-type');
        if (blockType === 'paragraph' || blockType === 'heading') {
          var textNode = targetElement.firstChild;
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            var textLength = textNode.textContent.replace(/\u200B/g, '').length;
            range.setStart(textNode, Math.min(textLength, textNode.textContent.length));
            range.setEnd(textNode, Math.min(textLength, textNode.textContent.length));
          } else {
            range.setStart(targetElement, 0);
            range.setEnd(targetElement, 0);
          }
        } else {
          range.setStart(targetElement, 0);
          range.setEnd(targetElement, 0);
        }
        selection.removeAllRanges();
        selection.addRange(range);
        targetElement.focus();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this11 = this;
      try {
        // Capture 'this' context for callbacks
        var self = this;

        // ========================================================================
        // FEATURED IMAGE: Drag-and-drop upload handler
        // ========================================================================
        var featuredImageDropzone = document.querySelector('#stack-featured-image-dropzone');
        if (featuredImageDropzone) {
          this.app.browser.addDragAndDropFileUploadToElement('stack-featured-image-dropzone', function (fileData) {
            if (!fileData) {
              console.warn('Stack: Failed to read featured image file');
              return;
            }

            // Handle multiple files: use only the last one
            // fileData is already base64 data URL from the helper
            if (typeof fileData === 'string' && fileData.startsWith('data:image/')) {
              // Extract base64 data (everything after the comma)
              var base64Data = fileData.split(',')[1];
              self.handleFeaturedImageUpload(base64Data);
            } else {
              console.warn('Stack: Invalid image data format');
            }
          }, true // click_to_upload
          );
        }

        // Thumbnail click uses the same replace/upload path as the dropzone
        var featuredImagePreview = document.querySelector('#stack-featured-image-preview');
        if (featuredImagePreview && featuredImageDropzone) {
          featuredImagePreview.addEventListener('click', function (e) {
            e.preventDefault();
            featuredImageDropzone.click();
          });
        }

        // Admin element (draft-state) - always clickable
        var adminElement = document.querySelector('#stack-draft-state');
        if (adminElement) {
          adminElement.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this11.handlePublishTriggerClick();
          });
          // Ensure element is always clickable
          adminElement.style.pointerEvents = 'auto';
          adminElement.style.cursor = 'pointer';
        }

        // Publish button in sidebar - opens publish settings overlay
        var publishBtn = document.querySelector('#stack-editor-publish-btn');
        if (publishBtn) {
          publishBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this11.handlePublishTriggerClick();
          });
        }

        // Cover image remove (sidebar thumbnail)
        var featuredImageDisplayRemove = document.querySelector('#stack-featured-image-display-remove');
        if (featuredImageDisplayRemove) {
          featuredImageDisplayRemove.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this11.handleFeaturedImageRemove();
            _this11.scheduleSerialization();
          });
        }

        // Title field — wrapping textarea; muted "Untitled" empty state
        var titleInput = document.querySelector('#stack-post-title-input');
        if (titleInput) {
          this.syncTitleFieldHeight(titleInput);
          titleInput.addEventListener('focus', function () {
            if (_this11.isUntitledPlaceholder(titleInput)) {
              titleInput.select();
            }
          });
          titleInput.addEventListener('input', function () {
            if (titleInput.classList.contains('is-empty')) {
              titleInput.classList.remove('is-empty');
            }
            if (!(titleInput.value || '').trim()) {
              // Keep field empty while typing/deleting; restore Untitled on blur
              titleInput.classList.remove('is-empty');
            }
            _this11.syncTitleFieldHeight(titleInput);
            _this11.updateNextStepButton();
            _this11.updatePublishTriggerVisibility();
            _this11.scheduleSerialization();
          });

          // Handle Enter and Tab to move to body editor
          titleInput.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === 'Tab') {
              e.preventDefault();
              e.stopPropagation();
              if (!(titleInput.value || '').trim()) {
                _this11.setDocumentTitle('');
              } else {
                titleInput.classList.remove('is-empty');
              }
              _this11.focusBodyEditorAtEnd();
            }
          });
          titleInput.addEventListener('blur', function () {
            if (!(titleInput.value || '').trim() || _this11.isUntitledPlaceholder(titleInput)) {
              _this11.setDocumentTitle('');
            }
          });
        }

        // Next step button (Preview)
        var nextStepBtn = document.querySelector('#stack-next-step-btn');
        if (nextStepBtn) {
          nextStepBtn.onclick = function (e) {
            e.preventDefault();
            if (!nextStepBtn.disabled && _this11.mod.previewOverlay) {
              _this11.mod.previewOverlay.render();
            }
          };
        }

        // Editor keyboard and input handlers
        var editor = document.querySelector('#stack-post-body-editor');
        if (editor) {
          // Handle Enter key
          editor.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && !e.shiftKey) {
              _this11.handleEnterKey(e);
            } else if (e.key === 'Enter' && e.shiftKey) {
              _this11.handleShiftEnterKey(e);
            } else if (e.key === 'Backspace') {
              _this11.handleBackspaceKey(e);
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
              _this11.handleArrowKey(e);
            } else if (e.key === 'Delete') {
              _this11.handleDeleteKey(e);
            }
          });

          // Handle input events
          editor.addEventListener('input', function (e) {
            _this11.handleEditorInput(e);
          });

          // Handle IME composition events to prevent saving during composition
          editor.addEventListener('compositionstart', function () {
            _this11.isComposing = true;
          });
          editor.addEventListener('compositionend', function () {
            _this11.isComposing = false;
            // Schedule save after composition ends
            _this11.scheduleSerialization();
          });

          // Handle paste events
          editor.addEventListener('paste', function (e) {
            _this11.handlePaste(e);
          });

          // Handle drag and drop
          editor.addEventListener('dragover', function (e) {
            _this11.handleDragOver(e);
          });
          editor.addEventListener('dragleave', function (e) {
            _this11.handleDragLeave(e);
          });
          editor.addEventListener('drop', function (e) {
            _this11.handleDrop(e);
          });

          // Handle clicks on image blocks to show/hide caption
          editor.addEventListener('click', function (e) {
            var imageBlock = e.target.closest('figure[data-block-type="image"]');
            if (imageBlock) {
              _this11.handleImageClick(imageBlock);
            } else {
              // Deselect all images when clicking elsewhere
              _this11.deselectAllImages();
            }
          });
        }
      } catch (err) {
        console.error('CreatePost attachEvents error:', err);
      }
    }

    /**
     * Update sidebar cover preview. Cover never enters the writing canvas.
     */
  }, {
    key: "updateFeaturedImageDisplay",
    value: function updateFeaturedImageDisplay() {
      var featuredImageDisplay = document.querySelector('#stack-featured-image-display');
      var featuredImageDisplayImg = document.querySelector('#stack-featured-image-display-img');
      var coverLabel = document.querySelector('#stack-featured-image-dropzone .text');
      var coverDropzone = document.querySelector('#stack-featured-image-dropzone');
      if (this.featuredImage && featuredImageDisplay && featuredImageDisplayImg) {
        featuredImageDisplay.classList.add('is-visible');
        featuredImageDisplayImg.src = "data:image/png;base64,".concat(this.featuredImage);
        featuredImageDisplayImg.alt = 'Cover image';
        if (coverLabel) {
          coverLabel.textContent = 'Replace cover';
        }
        if (coverDropzone) {
          coverDropzone.setAttribute('aria-label', 'Replace cover image');
        }
      } else {
        if (featuredImageDisplay) {
          featuredImageDisplay.classList.remove('is-visible');
        }
        if (featuredImageDisplayImg) {
          featuredImageDisplayImg.src = '';
          featuredImageDisplayImg.alt = '';
        }
        if (coverLabel) {
          coverLabel.textContent = 'Add cover image';
        }
        if (coverDropzone) {
          coverDropzone.setAttribute('aria-label', 'Add cover image');
        }
      }
    }

    /**
     * Handle featured image upload
     * @param {string} base64Data - Base64 image data (without data URL prefix)
     */
  }, {
    key: "handleFeaturedImageUpload",
    value: function () {
      var _handleFeaturedImageUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(base64Data) {
        var processedBase64, dataUrl, resizedDataUrl, _t6;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              if (base64Data) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              // Resize image if resizeImg is available
              processedBase64 = base64Data;
              if (!(this.app.browser && this.app.browser.resizeImg)) {
                _context1.n = 5;
                break;
              }
              _context1.p = 2;
              dataUrl = "data:image/png;base64,".concat(base64Data);
              _context1.n = 3;
              return this.app.browser.resizeImg(dataUrl);
            case 3:
              resizedDataUrl = _context1.v;
              processedBase64 = resizedDataUrl.split(',')[1] || base64Data;
              _context1.n = 5;
              break;
            case 4:
              _context1.p = 4;
              _t6 = _context1.v;
              console.warn('Stack: Image resize failed, using original:', _t6);
            // Use original if resize fails
            case 5:
              // Store featured image in editor state
              this.featuredImage = processedBase64;

              // Update display
              this.updateFeaturedImageDisplay();

              // Trigger autosave to persist featured image
              this.scheduleSerialization();

              // If publish settings overlay is open, update it too
              if (this.mod.publishSettingsOverlay && this.mod.publishSettingsOverlay.postState) {
                this.mod.publishSettingsOverlay.postState.image = processedBase64;
                if (typeof this.mod.publishSettingsOverlay.updateFeaturedImageDropzone === 'function') {
                  this.mod.publishSettingsOverlay.updateFeaturedImageDropzone(processedBase64);
                }
              }
            case 6:
              return _context1.a(2);
          }
        }, _callee1, this, [[2, 4]]);
      }));
      function handleFeaturedImageUpload(_x6) {
        return _handleFeaturedImageUpload.apply(this, arguments);
      }
      return handleFeaturedImageUpload;
    }()
    /**
     * Handle featured image removal
     */
  }, {
    key: "handleFeaturedImageRemove",
    value: function handleFeaturedImageRemove() {
      this.featuredImage = null;
      this.updateFeaturedImageDisplay();

      // If publish settings overlay is open, update it too
      if (this.mod.publishSettingsOverlay && this.mod.publishSettingsOverlay.postState) {
        this.mod.publishSettingsOverlay.postState.image = null;
        this.mod.publishSettingsOverlay.updateFeaturedImageDropzone(null);
      }
    }
  }]);
}();
module.exports = CreatePost;